// src/components/ThreadsViewer.js
import React, { useState, useEffect, useRef, useMemo, useContext } from 'react';
import './ThreadsViewer.css';
import paperClipButton from '../assets/paper-clip-button.png';
import ControlAgenteIA from '../assets/Control-Agente-IA.png';
import AgregarNota from '../assets/Agregar-Nota.png';
import webChatIcon from '../assets/web-chat-icon.png';
import flechaBaja from '../assets/flecha-baja.png';
import { VariableSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';


import { useAuth } from '../context/AuthContext'; 
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import emojiIconChat from '../assets/emoji-icon-chat.png';
import clipIconChat from '../assets/clip-icon-chat.png';

import EmojiPicker from 'emoji-picker-react';

import { getAllAssistants } from '../services/openaiService';
import { faBullseye, faSliders, faCheck, faTimes, faStop, faCog, faFile, faTags, faPlus, faDownload } from '@fortawesome/free-solid-svg-icons';
import seleccionarPlantillas from '../assets/seleccionar-plantillas.png';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faStar as faStarSolid,
  faCaretDown,
  faTrashAlt,
  faEllipsisV,
  faSearch,
  faFileAlt,
  faPencil,
} from '@fortawesome/free-solid-svg-icons';

import { FaWhatsapp } from 'react-icons/fa';
import microphoneIcon from '../assets/microphone.png';
import VoiceMessagePlayer from './VoiceMessagePlayer';

import backgroundChat from '../assets/background-chat.png';

import { faStar as faStarRegular } from '@fortawesome/free-regular-svg-icons';

import { SelectedTeamMemberContext } from '../context/SelectedTeamMemberContext';

import { getAuth } from 'firebase/auth'; // Si usas Firebase auth
import { auth } from '../firebase';
import { getToken } from '../auth';

import { db } from '../firebase';
import {
  collection,
  query,
  onSnapshot,
  updateDoc,
  getDocs,
  doc,
  getDoc,
  deleteDoc,
  where,
  arrayUnion,
  setDoc,
  arrayRemove,
  limit,
  startAfter,
  orderBy as fbOrderBy,
  increment,
} from 'firebase/firestore';

import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import TiendaNubeConnectForm from './TiendaNubeConnectForm';
import { toast } from 'react-toastify';
import { flushSync } from 'react-dom';
import * as XLSX from 'xlsx';


// Configurar worker de PDF.js
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const ThreadsViewer = ({ mobileTopOffset }) => {
  const [isDownloadingContacts, setIsDownloadingContacts] = useState(false);

const getRowHeight = (index) => {
  const isLoaderRow =
    loadingAllThreads && index === finalDisplayedThreads.length;
  if (isLoaderRow) return 56; // altura fija de la fila “soft-loading”

  const thread = finalDisplayedThreads[index];
  const tagLines = Math.ceil((thread?.etiquetas?.length || 0) / 3);
  const extra = tagLines ? tagLines * 16 : 0;
  return 80 + extra;
};

const downloadContactsXlsx = async () => {
  if (!assistantId) {
    toast.info('ℹ️ Selecciona un asistente primero.');
    return;
  }

  if (isDownloadingContacts) return;

  setIsDownloadingContacts(true);

  try {
    const token = await getToken();
    if (!token) {
      toast.error('❌ Debes iniciar sesión nuevamente.');
      return;
    }

    const res = await fetch(`https://backend.thethingapp.com/api/assistants/${assistantId}/export-contacts`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      throw new Error(body.error || 'Error exportando contactos.');
    }

    const { contacts } = await res.json();
    if (!Array.isArray(contacts) || contacts.length === 0) {
      toast.info('ℹ️ No hay contactos para exportar.');
      return;
    }

    const data = [['Nombre', 'Número de Teléfono']];
    contacts.forEach((c) => {
      data.push([
        c.name || 'Chat Web',
        formatPhoneNumber ? formatPhoneNumber(c.phone) : (c.phone || ''),
      ]);
    });

    const worksheet = XLSX.utils.aoa_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Contactos');

    const filename = `assistant-${assistantId}-contactos-${new Date()
      .toISOString()
      .slice(0, 19)
      .replace(/[:T]/g, '-')}.xlsx`;
    XLSX.writeFile(workbook, filename);

    toast.success('✔️ Exportando contactos…');
  } catch (error) {
    console.error('Error exportando contactos:', error);
    toast.error(`❌ ${error.message}`);
  } finally {
    setIsDownloadingContacts(false);
  }
};

const downloadAllConversations = async () => {
  if (!assistantId) {
    toast.info('ℹ️ Selecciona un asistente primero.');
    return;
  }

  try {
    const token = await getToken();
    if (!token) {
      toast.error('❌ Debes iniciar sesión nuevamente.');
      return;
    }

    const res = await fetch(`https://backend.thethingapp.com/api/assistants/${assistantId}/export-threads`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      throw new Error(body.error || 'Error descargando conversaciones.');
    }

    const { threads } = await res.json();

    if (!Array.isArray(threads) || threads.length === 0) {
      toast.info('ℹ️ No hay conversaciones para exportar.');
      return;
    }

    const filename = `assistant-${assistantId}-threads-${new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-')}.json`;
    downloadJSON({ assistantId, threads }, filename);
    toast.success('✔️ Exportando conversaciones…');
  } catch (error) {
    console.error('Error exportando conversaciones:', error);
    toast.error(`❌ ${error.message}`);
  }
};



  const [selectedAgent, setSelectedAgent] = useState(null);
  const [isOrderDropdownOpen, setIsOrderDropdownOpen] = useState(false);
  const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(false);
  const [showTiendaNubeModal, setShowTiendaNubeModal] = useState(false);
  const [filter, setFilter] = useState(null); // Para filtrar (por ejemplo, 'favorites')
  const filterDropdownRef = useRef(null);

  const [filterByDate, setFilterByDate] = useState(null); // Para filtrar por fecha (ISO string, "YYYY-MM-DD")

  const [filterStartDate, setFilterStartDate] = useState(null);
  const [filterEndDate, setFilterEndDate] = useState(null);

  const [allThreads, setAllThreads] = useState(null);
const [loadingAllThreads, setLoadingAllThreads] = useState(false);


  const location = useLocation();

  const { selectedTeamMember, setSelectedTeamMember } =
    useContext(SelectedTeamMemberContext);
  const [selectedTeamMemberId, setSelectedTeamMemberId] = useState(null);

  const [agents, setAgents] = useState([]);
  const [filteredAgents, setFilteredAgents] = useState([]);
  const [agentSearchTerm, setAgentSearchTerm] = useState('');
  const [threads, setThreads] = useState([]);

  const [selectedThread, setSelectedThread] = useState(null);
  const [loadingAgents, setLoadingAgents] = useState(true);
  const [loadingThreads, setLoadingThreads] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [newMessage, setNewMessage] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [showTemplateDropdown, setShowTemplateDropdown] = useState(false);

  const [templateExists, setTemplateExists] = useState(false);
  const [checkingTemplate, setCheckingTemplate] = useState(false);

  const [noAgents, setNoAgents] = useState(false);

  // ====== Switch local / global de Autorespuesta
  const [isAutoResponseEnabled, setIsAutoResponseEnabled] = useState(true);
  const [globalAutoResponseEnabled, setGlobalAutoResponseEnabled] =
    useState(true);

  // Estado que se usará para saber si debemos forzar el scroll al final
  const [scrollOnLoad, setScrollOnLoad] = useState(false);
  const [isUserNearBottom, setIsUserNearBottom] = useState(true);
  const [unreadThreadIds, setUnreadThreadIds] = useState([]);

  const [isEditingSender, setIsEditingSender] = useState(false);
const [editedSenderName, setEditedSenderName] = useState('');
const [applyToAllWithNumber, setApplyToAllWithNumber] = useState(true);

const startEditSender = () => {
  setIsEditingSender(true);
  setEditedSenderName(selectedThread?.senderName || '');
};

const cancelEditSender = () => {
  flushSync(() => {
    setIsEditingSender(false);
    setEditedSenderName('');
  });
};


const saveSenderName = () => {
  if (!selectedThread) return;

  const newName = editedSenderName.trim();
  const oldName = selectedThread?.senderName || '';
  if (!newName) { cancelEditSender(); return; }
  if (newName === oldName) { cancelEditSender(); return; }

  const { threadId, assistantId, phoneNumber } = selectedThread;

  // 1) UI inmediata (optimista): actualiza y cierra edición YA
  flushSync(() => {
    setSelectedThread(prev => prev ? { ...prev, senderName: newName } : prev);
    setThreads(prev => prev.map(t => t.threadId === threadId ? { ...t, senderName: newName } : t));
    setAllThreads(prev => Array.isArray(prev)
      ? prev.map(t => t.threadId === threadId ? { ...t, senderName: newName } : t)
      : prev
    );
    setIsEditingSender(false);
    setEditedSenderName('');
  });

  // 2) Persistir en segundo plano (y aplicar a todos si corresponde)
  (async () => {
    try {
      // Este hilo
      await updateDoc(doc(db, `threads_${assistantId}`, threadId), { senderName: newName });

      // Aplicar a todos con el mismo número (costoso → no bloquear la UI)
      if (applyToAllWithNumber && phoneNumber) {
        const assistants = await getAllAssistants(currentUser.uid);
        await Promise.allSettled(
          assistants.map(async (a) => {
            const colRef = collection(db, `threads_${a.id}`);
            const q = query(colRef, where('phoneNumber', '==', phoneNumber));
            const snap = await getDocs(q);
            await Promise.allSettled(
              snap.docs.map(d => {
                if (a.id === assistantId && d.id === threadId) return null;
                return updateDoc(doc(db, `threads_${a.id}`, d.id), { senderName: newName });
              })
            );
          })
        );

        // Refrescos/cachés sin bloquear
        assistants.forEach(a => invalidateAllThreadsCache(a.id));
      } else {
        invalidateAllThreadsCache(assistantId);
      }

      toast.success('✔️ Nombre de contacto actualizado');
    } catch (err) {
      console.error('Error actualizando senderName:', err);

      // 3) Rollback si falló la persistencia
      setSelectedThread(prev => (prev && prev.threadId === threadId) ? { ...prev, senderName: oldName } : prev);
      setThreads(prev => prev.map(t => t.threadId === threadId ? { ...t, senderName: oldName } : t));
      setAllThreads(prev => Array.isArray(prev)
        ? prev.map(t => t.threadId === threadId ? { ...t, senderName: oldName } : t)
        : prev
      );
      toast.error('❌ No se pudo actualizar el nombre');
    }
  })();
};


function marcarOverflowTags() {
    document.querySelectorAll('.thread-item.wrap').forEach(item => {
      const bar = item.querySelector('.thread-tags');
      if (!bar) return;
      const hayOverflow = bar.scrollWidth > bar.clientWidth + 1;
      item.classList.toggle('tags-overflow', hayOverflow);
    });
  }

  // Al cargar y cuando cambia el tamaño
  window.addEventListener('load', marcarOverflowTags);
  window.addEventListener('resize', () => requestAnimationFrame(marcarOverflowTags));


  // Si prefieres que la función reciba el objeto "thread" completo:
async function markThreadAsUnread(thread) {
  if (!thread) return;

  const { assistantId, threadId } = thread;

  // 1) Feedback inmediato en UI
  setThreads(prev =>
    prev.map(t =>
      t.threadId === threadId ? { ...t, readByUser: false } : t
    )
  );

  setSelectedThread(prev =>
    prev && prev.threadId === threadId
      ? { ...prev, readByUser: false }
      : prev
  );

  setAllThreads(prev =>
    Array.isArray(prev)
      ? prev.map(t =>
          t.threadId === threadId ? { ...t, readByUser: false } : t
        )
      : prev
  );

  setGlobalSearchResults(prev =>
    Array.isArray(prev)
      ? prev.map(t =>
          t.threadId === threadId ? { ...t, readByUser: false } : t
        )
      : prev
  );

  // 2) Persistir en Firestore (si falla, solo logueamos, el estado se queda "no leído")
  try {
    const ref = doc(db, `threads_${assistantId}`, threadId);
    await updateDoc(ref, { readByUser: false });
  } catch (error) {
    console.error('Error al marcar el thread como no leído:', error);
    // Si quisieras hacer rollback, acá podrías volver a true
  }

  setIsMoveMenuOpen(null);
}


async function markThreadAsRead(thread) {
  if (!thread) return;

  const { assistantId, threadId } = thread;

  // 1) Feedback inmediato en UI (simétrico al "unread")
  setThreads(prev =>
    prev.map(t =>
      t.threadId === threadId ? { ...t, readByUser: true } : t
    )
  );

  setSelectedThread(prev =>
    prev && prev.threadId === threadId
      ? { ...prev, readByUser: true }
      : prev
  );

  setAllThreads(prev =>
    Array.isArray(prev)
      ? prev.map(t =>
          t.threadId === threadId ? { ...t, readByUser: true } : t
        )
      : prev
  );

  setGlobalSearchResults(prev =>
    Array.isArray(prev)
      ? prev.map(t =>
          t.threadId === threadId ? { ...t, readByUser: true } : t
        )
      : prev
  );

  // 2) Persistir en Firestore
  try {
    const ref = doc(db, `threads_${assistantId}`, threadId);
    await updateDoc(ref, { readByUser: true });
  } catch (error) {
    console.error('Error al marcar el thread como leído:', error);
    // Si quisieras, acá podrías revertir a false en los mismos estados
  }

  setIsMoveMenuOpen(null);
}


  const [assistantPassKey, setAssistantPassKey] = useState('');
  const [isSending, setIsSending] = useState(false);

  const [creatingTemplate, setCreatingTemplate] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const emojiPickerRef = useRef(null);

  const templateDropdownRef = useRef(null);
  const orderContainerRef = useRef(null);
  const [teamModalPosition, setTeamModalPosition] = useState({ top: 0, left: 0 });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPreviewIndex, setCurrentPreviewIndex] = useState(0);

  const [showOnlyUnread, setShowOnlyUnread] = useState(false);

  const [orderBy, setOrderBy] = useState('lastMessage');

  const { assistantId, threadId } = useParams();

  // Chequeo: ¿viene “team-XYZ”?
  let isTeamRoute = false;
  let teamMemberUniqueId = null;

  if (assistantId && assistantId.startsWith('team-')) {
    isTeamRoute = true;
    teamMemberUniqueId = assistantId.replace('team-', '');
  }

  const navigate = useNavigate();
  const { currentUser } = useAuth();

  // Manejo de conversaciones restantes
  const [totalThreads, setTotalThreads] = useState(0);
  const [purchasedThreads, setPurchasedThreads] = useState(0);
  const [remainingConversations, setRemainingConversations] = useState(6000);
  const [isLimitReached, setIsLimitReached] = useState(false);
  const [showConversationLimitModal, setShowConversationLimitModal] =
    useState(false);

  // Modal para asignar miembros
  const [isTeamModalOpen, setIsTeamModalOpen] = useState(false);
  const [teamMembers, setTeamMembers] = useState([]);

  // CRM
  const [crmColumns, setCrmColumns] = useState([]);
  const [isMoveMenuOpen, setIsMoveMenuOpen] = useState(null);
  const [isTagMenuOpen, setIsTagMenuOpen] = useState(false);

  // Búsqueda en mensajes
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [currentSearchIndex, setCurrentSearchIndex] = useState(0);

  // Búsqueda global
  const [isGlobalSearchOpen, setIsGlobalSearchOpen] = useState(false);
  const [globalSearchTerm, setGlobalSearchTerm] = useState('');
  const [globalSearchResults, setGlobalSearchResults] = useState([]);
  const [isGlobalSearchLoading, setIsGlobalSearchLoading] = useState(false);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [showMobileThreadList, setShowMobileThreadList] = useState(true);

  const [availableTemplates, setAvailableTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState('contacto');

  const [isInputFocused, setIsInputFocused] = useState(false);   // 👈 NUEVO
  // =========== Refs
  const messageHistoryRef = useRef(null);
  const lastMessageRef = useRef(null);
  const fileInputRef = useRef(null);
  const loadingTimeoutRef = useRef(null);
  const orderFilterRef = useRef(null);
  const messageRefs = useRef([]);
  const prevThreadsRef = useRef([]);

  // Manejo de archivos
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previewURLs, setPreviewURLs] = useState([]);

  // Justo en la parte de los useState:
  // Por ejemplo, en tu componente
  const [chosenTemplate, setChosenTemplate] = useState(null);

  const [isCreatingDefaults, setIsCreatingDefaults] = useState(false);

  const didThreadAutoSelect = useRef(false);

  // Justo luego de tu "const selectedThread = ...;"
  // o antes de setAlertVisible(false);
  const isAwaitingReply = selectedThread?.isWaitingUserReply ?? false;

  // ========== Lógica de chat “congelado” por 24h / awaitingReply

  const [alertVisible, setAlertVisible] = useState(isAwaitingReply); // Nuevo estado para controlar la alerta

// Estados para frases de seguimiento y el modal
const [showTrackingPhraseModal, setShowTrackingPhraseModal] = useState(false);
const [trackingPhrases, setTrackingPhrases] = useState([]);
const [selectedTrackingPhrase, setSelectedTrackingPhrase] = useState('');

// Para saber si el toggle actual es "global" o "individual"
const [isGlobalTrackingToggle, setIsGlobalTrackingToggle] = useState(false);


const DEFAULT_TAGS = [
  // ➊ Morado más firme para “cliente potencial”
  { nombre: "cliente potencial", color: "#9552fa" },

  // ➋ Verde-agua más profundo para “seguimiento”
  { nombre: "seguimiento",       color: "#77C0E0" }, 


  // ➌ Rojo-coral para “descartado”
  { nombre: "descartado",        color: "#bd3e48" }, 
];

/** 1️⃣  Decláralo hacia el comienzo del componente  */
const PREDEFINED_COLORS = [
  "#38ae03", // verde
  "#50aee4", // celeste
  "#9b6ee6",   // violeta
  "#F666C4", // rosa
  "#ee9304", // naranja

];

const TAG_TOAST_DURATION = 500;


const [tags,            setTags]            = useState([]);  // chips visibles
const [activeTags,      setActiveTags]      = useState([]);  // filtros aplicados
const [showTagCreator,  setShowTagCreator]  = useState(false);
const [newTagName,      setNewTagName]      = useState("");
const [newTagColor,     setNewTagColor]     = useState("#673AB7");
// justo donde tienes los demás useState de tags
const [editingTag,     setEditingTag]     = useState(null);   // {nombre,color} | null
const [showTagEditor,  setShowTagEditor]  = useState(false);
const [editName,       setEditName]       = useState("");
const [editColor,      setEditColor]      = useState("#673AB7");

const PAGE_SIZE = 50;           // ← 50 hilos por página
const [lastDoc,  setLastDoc]  = useState(null);  // último doc del lote actual
const [hasMore, setHasMore]   = useState(true);
const [loadingMore, setLoadingMore] = useState(false);
const [assistantChatsCount, setAssistantChatsCount] = useState(0);
const allThreadsRunIdRef = useRef(0);
const snapshotThreadsRef = useRef([]);
const extraThreadsRef = useRef([]);

useEffect(() => {
  if (!assistantId || isTeamRoute) return;
  setThreads([]);
  setLastDoc(null);
  setHasMore(true);
  setLoadingMore(false);
  snapshotThreadsRef.current = [];
  extraThreadsRef.current = [];
  // Invalidar caché cuando cambian filtros para evitar datos obsoletos
  invalidateAllThreadsCache(assistantId);
}, [assistantId, isTeamRoute, filterStartDate, filterEndDate, showOnlyUnread, filter]);

// ─────────────────────────────────────────────
// CACHÉ de "todos los threads" en localStorage
// ─────────────────────────────────────────────
const ALL_THREADS_CACHE_PREFIX = 'tt:allThreads:v2';
const makeCacheKey = (assistantId) => `${ALL_THREADS_CACHE_PREFIX}:${assistantId}`;

const slimForCache = (t) => ({
  threadId: t.threadId,
  assistantId: t.assistantId,
  senderName: t.senderName || '',
  phoneNumber: t.phoneNumber || null,
  userName: t.userName || null,
  isFavorite: !!t.isFavorite,
  readByUser: !!t.readByUser,
  lastMessageAt: t.lastMessageAt || t.messageHistory?.at(-1)?.createdAt || null,
  etiquetas: t.etiquetas || [],
  // Guardamos solo lo necesario para buscar/mostrar
  messageHistory: (t.messageHistory || []).map(m => ({
    role: m.role,
    content: m.content,
    createdAt: m.createdAt,
    messageType: m.messageType,
  })),
});

function saveAllThreadsCache(assistantId, threads, chatsCount) {
  try {
    const payload = {
      savedAt: Date.now(),
      chatsCount: chatsCount ?? null,
      threads: threads.map(slimForCache),
    };
    localStorage.setItem(makeCacheKey(assistantId), JSON.stringify(payload));
  } catch (e) {
    console.warn('No pude guardar cache de threads:', e);
  }
}

function readAllThreadsCache(assistantId) {
  try {
    const raw = localStorage.getItem(makeCacheKey(assistantId));
    if (!raw) return null;
    const obj = JSON.parse(raw);
   if (!Array.isArray(obj?.threads)) return null;
   const TTL_MS = 15 * 60 * 1000; // 15 min
  if (Date.now() - (obj.savedAt || 0) > TTL_MS) return null;
    return obj; // { threads, savedAt, chatsCount }
  } catch {
    return null;
  }
}

function invalidateAllThreadsCache(assistantId) {
  try { localStorage.removeItem(makeCacheKey(assistantId)); } catch {}
}

// Limpiar TODOS los cachés de threads al montar el componente
function clearAllThreadsCaches() {
  try {
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(ALL_THREADS_CACHE_PREFIX)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key));
  } catch (e) {
    console.warn('Error limpiando cachés de threads:', e);
  }
}





function buildFilteredQuery(colRef, {
  startDate,
  endDate,
  onlyUnread,
  onlyFavorites,
  pageSize,
  afterDoc
}) {
  const constraints = [];

  if (onlyUnread)    constraints.push(where('readByUser', '==', false));
  if (onlyFavorites) constraints.push(where('isFavorite', '==', true));
  if (startDate)     constraints.push(where('lastMessageAt', '>=', new Date(`${startDate}T00:00:00`)));
  if (endDate)       constraints.push(where('lastMessageAt', '<=', new Date(`${endDate}T23:59:59.999`)));

  constraints.push(fbOrderBy('lastMessageAt', 'desc'));
  if (afterDoc)      constraints.push(startAfter(afterDoc));
  constraints.push(limit(pageSize));

  return query(colRef, ...constraints);
}

function buildPagingQuery(colRef, { startDate, endDate, pageSize, afterDoc }) {
  const constraints = [];

  // Sólo rango por fecha (si hay)
  if (startDate) {
    constraints.push(
      where('lastMessageAt', '>=', new Date(`${startDate}T00:00:00`))
    );
  }
  if (endDate) {
    constraints.push(
      where('lastMessageAt', '<=', new Date(`${endDate}T23:59:59.999`))
    );
  }

  // Orden descendente y paginación
  constraints.push(fbOrderBy('lastMessageAt', 'desc'));
  if (afterDoc) constraints.push(startAfter(afterDoc));
  constraints.push(limit(pageSize));

  return query(colRef, ...constraints);
}

function dedupeTags(arr = []) {
  const map = new Map(); // key: nombre lowercased
  arr.forEach(t => {
    const nombre = (t?.nombre ?? t?.name ?? '').trim();
    if (!nombre) return;
    if (!map.has(nombre.toLowerCase())) {
      map.set(nombre.toLowerCase(), { nombre, color: t?.color || '#777' });
    }
  });
  return Array.from(map.values()).sort((a,b)=> a.nombre.localeCompare(b.nombre));
}


useEffect(() => {
  // sin assistantId y sin team, no hay nada que escuchar
  if (!currentUser) return;

  // ───────── team: unión de todos los assistants del usuario ─────────
  if (isTeamRoute) {
    let unsubscribers = [];
    const perAssistant = new Map(); // assistantId -> tags[]

    (async () => {
      try {
        const assistants = await getAllAssistants(currentUser.uid);
        // si no hay assistants, dejamos defaults
        if (!assistants?.length) { setTags(DEFAULT_TAGS); return; }

        unsubscribers = assistants.map(a => {
          const ref = doc(db, "assistants", a.id);
          return onSnapshot(ref, snap => {
            const ets = Array.isArray(snap.data()?.etiquetas) ? snap.data().etiquetas : [];
            perAssistant.set(a.id, ets);
            const union = dedupeTags([...(perAssistant.values())].flat());
            setTags(union.length ? union : DEFAULT_TAGS);
          });
        });
      } catch (e) {
        console.error('Team tags union error:', e);
        setTags(DEFAULT_TAGS);
      }
    })();

    return () => unsubscribers.forEach(u => { try { u && u(); } catch {} });
  }

  // ───────── vista normal: etiquetas del assistant actual ─────────
  if (!assistantId) { setTags([]); return; }

  const aRef = doc(db, "assistants", assistantId);
  const unsub = onSnapshot(aRef, async (snap) => {
    if (!snap.exists()) { setTags(DEFAULT_TAGS); return; }
    const data = snap.data() || {};
    if (!Array.isArray(data.etiquetas) || data.etiquetas.length === 0) {
      try {
        await updateDoc(aRef, { etiquetas: DEFAULT_TAGS });
        setTags(DEFAULT_TAGS);
      } catch {
        await setDoc(aRef, { etiquetas: DEFAULT_TAGS }, { merge: true });
        setTags(DEFAULT_TAGS);
      }
    } else {
      setTags(data.etiquetas);
    }
  });
  return () => unsub();
}, [assistantId, isTeamRoute, currentUser]);


// Devuelve una **copia** ordenada DESC por fecha del último mensaje
function sortByLastMessageDesc(arr) {
  return [...arr].sort((a, b) => {
    const aLast = new Date(a?.messageHistory?.at?.(-1)?.createdAt || 0);
    const bLast = new Date(b?.messageHistory?.at?.(-1)?.createdAt || 0);
    return bLast - aLast;
  });
}

function mergeThreadsLists(current = [], incoming = []) {
  if (!incoming.length) return current;
  const map = new Map(current.map(t => [t.threadId, t]));
  incoming.forEach(t => {
    if (!t?.threadId) return;
    const prev = map.get(t.threadId);
    map.set(t.threadId, prev ? { ...prev, ...t } : t);
  });
  return sortByLastMessageDesc(Array.from(map.values()));
}

// 1) añadí un ref al textarea
const inputRef = useRef(null);

useEffect(() => {
  const el = inputRef.current;
  if (!el) return;
  el.style.height = 'auto';
  const singleRowHeight = el.clientHeight;
  if (el.scrollHeight > singleRowHeight) {
    el.style.height = `${el.scrollHeight}px`;
  }
}, [newMessage]);


  function isOlderThan24Hours(dateString) {
    if (!dateString) return false;
    const now = new Date();
    const msgDate = new Date(dateString);
    const diff = now - msgDate;
    return diff > 24 * 60 * 60 * 1000;
  }

  const lastMsg =
    selectedThread?.messageHistory?.[
      selectedThread?.messageHistory.length - 1
    ];
  const has24hPassedSinceLastMsg = lastMsg
    ? isOlderThan24Hours(lastMsg.createdAt)
    : false;

  // 1) ¿El último mensaje es plantilla o normal?
  const lastMessageIsTemplate = lastMsg && isTemplateMessage(lastMsg);
  const lastMessageIsNormal = !!lastMsg && !lastMessageIsTemplate;

  // 2) ¿Ha pasado más de 24h desde el último mensaje?
  const moreThan24hSinceLastMsg = lastMsg
    ? isOlderThan24Hours(lastMsg.createdAt)
    : false;

  // 3) Solo nos importa congelar si el último fue NORMAL *y* pasaron +24h
  const freezeIfLastNormalOver24h = lastMessageIsNormal && moreThan24hSinceLastMsg;
  

  const lastNormalMessage = getLastNonTemplateMessage(
    selectedThread?.messageHistory
  );
  const olderThan24 = lastNormalMessage
    ? isOlderThan24Hours(lastNormalMessage.createdAt)
    : false;

  function isOlderThan24HoursX(dateString) {
    if (!dateString) return false;
    const now = new Date();
    const msgDate = new Date(dateString);
    const diff = now - msgDate;
    return diff > 24 * 60 * 60 * 1000; // true si > 24 horas
  }

  const freezeFaFile = (selectedThread?.templateCountNoReply24h || 0) >= 2;

  // BULK: dropdowns (CRM y Etiquetas)
const [isBulkTagsOpen, setIsBulkTagsOpen] = useState(false);
const [isBulkCrmOpen,  setIsBulkCrmOpen]  = useState(false);

const bulkTagsRef = useRef(null);
const bulkCrmRef  = useRef(null);


  // Nueva regla: se congela si:
  //  (A) excediste las 2 plantillas sin respuesta (<24h)  -- freezeFaFile
  //  (B) estás en awaitingReply                           -- isAwaitingReply
  //  (C) el último fue NORMAL y han pasado >24h           -- freezeIfLastNormalOver24h
  function computeIsChatFrozen(thread) {
    if (!thread) return false;
    // 1) isAwaitingReply
    const isAwaitingReplyLocal = !!thread.isWaitingUserReply;

    // 2) ¿Cuántas plantillas sin respuesta?
    const templatesNoReply = thread.templateCountNoReply24h || 0;

    // 3) Último mensaje normal
    const lastNormal = getLastNonTemplateMessage(thread.messageHistory);
    const olderThan24Local = lastNormal
      ? isOlderThan24Hours(lastNormal.createdAt)
      : false;

    // 4) Reglas:
    //   - Si isAwaitingReply => freeze
    //   - Si se han enviado 2 plantillas sin respuesta (>=2) Y el último normal es >24h => freeze
    const freezeByTwoTemplates = templatesNoReply >= 2 && olderThan24Local;

    return isAwaitingReplyLocal || freezeByTwoTemplates;
  }

  const isChatFrozen = useMemo(
    () => computeIsChatFrozen(selectedThread),
    [selectedThread]
  );

  // Devuelve un objeto con 2 flags:
  //  - partial: boolean (bloqueo parcial; solo se pueden enviar plantillas)
  //  - total:   boolean (bloqueo total; ni siquiera plantillas)
  function getFreezeState(thread) {
    if (!thread) {
      return { partial: false, total: false };
    }

    // 1) Tomar último mensaje normal
    const lastNormal = getLastNonTemplateMessage(thread.messageHistory);
    if (!lastNormal) {
      // Si nunca hubo un mensaje normal, no hay “+24hs”
      return { partial: false, total: false };
    }

    // 2) Verificar si pasaron 24hs desde el último mensaje normal
    const olderThan24Local = isOlderThan24Hours(lastNormal.createdAt);

    // 3) ¿Cuántas plantillas van sin respuesta?
    const tplCount = thread.templateCountNoReply24h || 0;

    // 4) Reglas:
    //    - Si NO pasaron 24hs => no hay freeze
    if (!olderThan24Local) {
      return { partial: false, total: false };
    }

    //    - Si pasaron 24hs, pero tplCount < 2 => "bloqueo parcial"
    if (tplCount < 2) {
      return { partial: true, total: false };
    }

    //    - Si pasaron 24hs y tplCount >= 2 => "bloqueo total"
    return { partial: false, total: true };
  }

  const { partial: isPartialFreeze, total: isTotalFreeze } = useMemo(
    () => getFreezeState(selectedThread),
    [selectedThread]
  );

  // REGLA PARA INPUT DE TEXTO, ÍCONOS DE EMOJI, CLIP, MIC
  const shouldDisableNormalControls = isTotalFreeze || isPartialFreeze;

  // REGLA: si es total => bloqueado; si es partial => habilitados
  //        si no hay freeze => habilitado
  const shouldDisableTemplateControls = isTotalFreeze;

  // Esto va a controlar el input normal, emoji, clip, mic
  const disableNormalControls = isPartialFreeze || isTotalFreeze;
  // Para .file-icon-inside-input y .send-message-buttons
  const disableTemplateControls = isTotalFreeze;

  // Estado para saber si YA existen las 3 plantillas "tt_..."
  const [hasAllDefaultTemplates, setHasAllDefaultTemplates] = useState(false);

  const [isTiendaNubeConnected, setIsTiendaNubeConnected] = useState(false);
  const [tnProducts, setTnProducts] = useState([]);
  const [showProductDropdown, setShowProductDropdown] = useState(false);

  // Agrega estos dos estados en ThreadsViewer
  const [crmDropdownOpenThreadId, setCrmDropdownOpenThreadId] = useState(null);
// justo con los otros useState relacionados a menús
const [tagDropdownOpenThreadId, setTagDropdownOpenThreadId] = useState(null);

  const [hoveredCrmThreadId, setHoveredCrmThreadId] = useState(null);

  const [isAutoMenuOpen, setIsAutoMenuOpen] = useState(false);

  // ➜ conservamos ambos, pero cada setter CERRARÁ el otro
function openCrm(id)  { setTagDropdownOpenThreadId(null); setCrmDropdownOpenThreadId(id); }
function openTags(id) { setCrmDropdownOpenThreadId(null); setTagDropdownOpenThreadId(id); }
function closeAll()   { setCrmDropdownOpenThreadId(null); setTagDropdownOpenThreadId(null); }
  

// arriba del componente
const filterContainerRef = useRef(null);

  // Agrega un state para saber si el usuario ha seleccionado manualmente
  const [hasManuallySelectedThread, setHasManuallySelectedThread] =
    useState(false);

// justo donde defines tus useState:


// ═══════════════════════════════════════════════════════════════════════════
// NUEVO SISTEMA DE FILTROS: Carga paginada solo cuando hay filtros por etiquetas
// o búsqueda global. NO carga todo al montar el componente.
// ═══════════════════════════════════════════════════════════════════════════

// Detectar si hay filtros que requieren cargar todos los threads (etiquetas o búsqueda)
const needsFullLoad = activeTags.length > 0 || isGlobalSearchOpen;

useEffect(() => {
  // Si no hay assistantId o no necesitamos cargar todo, limpiar y salir
  if (!assistantId || !needsFullLoad) {
    allThreadsRunIdRef.current++;   // cancela bucles while en curso
    setAllThreads(null);            // soltar la lista completa
    setLoadingAllThreads(false);
    return;
  }

  // Si ya tenemos datos en memoria y no cambió el filtro, no recargar
  if (allThreads?.length && !loadingAllThreads) {
    return;
  }

  // NO usar caché - siempre cargar datos frescos de Firestore
  // para evitar mostrar threads eliminados que quedaron en localStorage

  // Iniciar carga paginada
  const runId = ++allThreadsRunIdRef.current;
  setLoadingAllThreads(true);

  (async () => {
    try {
      const colRef = collection(db, `threads_${assistantId}`);
      let all = [];
      let lastDocLocal = null;
      const MAX_PAGES = 20; // máximo 1000 threads (20 * 50)

      for (let page = 0; page < MAX_PAGES; page++) {
        // Verificar si se canceló la operación
        if (allThreadsRunIdRef.current !== runId) break;

        const constraints = [fbOrderBy('lastMessageAt', 'desc')];
        if (lastDocLocal) constraints.push(startAfter(lastDocLocal));
        constraints.push(limit(PAGE_SIZE));

        const q = query(colRef, ...constraints);
        const snap = await getDocs(q);

        // Verificar cancelación después de la query
        if (allThreadsRunIdRef.current !== runId) break;

        const docs = snap.docs;
        const newThreads = docs.map(d => ({
          threadId: d.id,
          ...d.data(),
          assistantId
        }));
        all = [...all, ...newThreads];

        // Actualizar estado incremental para mostrar resultados mientras carga
        setAllThreads([...all]);

        // Si no hay más páginas, terminar
        if (docs.length < PAGE_SIZE) break;
        lastDocLocal = docs.at(-1);
      }

      // NO guardar en caché - siempre queremos datos frescos de Firestore
      // para evitar mostrar threads eliminados
    } catch (err) {
      console.error('Error cargando threads para filtros:', err);
    } finally {
      if (allThreadsRunIdRef.current === runId) {
        setLoadingAllThreads(false);
      }
    }
  })();
}, [
  assistantId,
  needsFullLoad, // Solo recarga si cambia esta condición
]);

  useEffect(() => {
    function handleClickOutside(event) {
      // Si el contenedor existe y el click no está dentro de él:
      if (
        emojiPickerRef.current &&
        !emojiPickerRef.current.contains(event.target)
      ) {
        setShowEmojiPicker(false);
      }
    }

    // Escuchar mousedown (o click) en el documento
    document.addEventListener('click', handleClickOutside);

    return () => {
      // Limpieza: dejar de escuchar cuando se desmonte
      document.removeEventListener('click', handleClickOutside);
    };
  }, [showEmojiPicker]);

  useEffect(() => {
    function handleFilterClickOutside(e) {
      if (
        isFilterDropdownOpen &&
        filterDropdownRef.current &&
        !filterDropdownRef.current.contains(e.target)
      ) {
        setIsFilterDropdownOpen(false);
      }
    }
    document.addEventListener('click', handleFilterClickOutside);
    return () => {
      document.removeEventListener('click', handleFilterClickOutside);
    };
  }, [isFilterDropdownOpen]);

  useEffect(() => {
    function handleClickOutside(e) {
      if (
        isOrderDropdownOpen &&
        orderContainerRef.current &&
        !orderContainerRef.current.contains(e.target)
      ) {
        setIsOrderDropdownOpen(false);
      }
    }
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isOrderDropdownOpen]);

  useEffect(() => {
    function handleClickOutside(event) {
      // Si la dropdown está visible y el clic no fue dentro de ella:
      if (
        showTemplateDropdown &&
        templateDropdownRef.current &&
        !templateDropdownRef.current.contains(event.target)
      ) {
        setShowTemplateDropdown(false);
      }
    }

    // Listener global en "click"
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [showTemplateDropdown]);

  useEffect(() => {
    if (!availableTemplates || availableTemplates.length === 0) {
      setHasAllDefaultTemplates(false);
      return;
    }

    // Queremos saber si están las 3:
    const needed = [
      'tt_contacto',
      'tt_en_linea',
      'tt_que_necesitas',
      'tt_confirmar_recepcion',
      'tt_necesitas_ayuda',
    ];
    const existingCount = availableTemplates.filter((tpl) =>
      needed.includes(tpl.name)
    ).length;
    setHasAllDefaultTemplates(existingCount === 5);
  }, [availableTemplates]);

  // UseEffect para manejar la desaparición de la alerta
  useEffect(() => {
    if (isAwaitingReply === false) {
      setAlertVisible(false); // Si isWaitingUserReply es false, ocultamos la alerta
    } else {
      setAlertVisible(true); // Si isWaitingUserReply es true, mostramos la alerta
    }
  }, [isAwaitingReply]);

  // ============== EFFECTS & LISTENERS ==============

  // Ajuste de tamaño (mobile)
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (windowWidth <= 1000) {
      setShowMobileThreadList(true);
      setSelectedThread(null);
    }
  }, [windowWidth]);

  const isMobile = windowWidth <= 1000;
  const isInThreadDetail = /^\/messages\/[^/]+\/[^/]+$/.test(location.pathname);
  const shouldUseFixed = isMobile && isInThreadDetail;

  // Estados para grabar audio
  const [isRecording, setIsRecording] = useState(false);
  const [mediaRecorder, setMediaRecorder] = useState(null);

  // Función para iniciar la grabación
  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const localChunks = [];

      let mimeType = 'audio/webm';
      let extension = 'webm';
      if (MediaRecorder.isTypeSupported('audio/mp4')) {
        mimeType = 'audio/mp4';
        extension = 'm4a';
      } else if (MediaRecorder.isTypeSupported('audio/webm;codecs=opus')) {
        mimeType = 'audio/webm;codecs=opus';
      }

      const recorder = new MediaRecorder(stream, { mimeType });
      recorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          localChunks.push(event.data);
        }
      };
      recorder.onstop = () => {
        const audioBlob = new Blob(localChunks, { type: mimeType });
        const audioFile = new File([audioBlob], `audio-grabado.${extension}`, {
          type: mimeType,
        });
        setSelectedFiles((prev) => [...prev, audioFile]);
        setPreviewURLs((prev) => [
          ...prev,
          {
            type: 'audio',
            url: URL.createObjectURL(audioFile),
            name: audioFile.name,
          },
        ]);
      };

      recorder.start();
      setMediaRecorder(recorder);
      setIsRecording(true);
    } catch (error) {
      console.error('Error al acceder al micrófono:', error);
    }
  };

  // Función para detener la grabación
  const stopRecording = () => {
    if (mediaRecorder) {
      mediaRecorder.stop();
      mediaRecorder.stream.getTracks().forEach((track) => track.stop());
      setIsRecording(false);
    }
  };

  // Limpiar cachés obsoletos al montar el componente
  useEffect(() => {
    clearAllThreadsCaches();
  }, []);

  // Listener de usuario => globalAutoResponseEnabled, totalThreads, etc.
  useEffect(() => {
    if (!currentUser) return;
    const userDocRef = doc(db, 'users', currentUser.uid);
    const unsubscribeUser = onSnapshot(userDocRef, (docSnapshot) => {
      if (docSnapshot.exists()) {
        const userData = docSnapshot.data();
        const updatedTotalThreads = userData.totalThreads || 0;
        const updatedPurchasedThreads = userData.purchasedThreads || 0;
        setTotalThreads(updatedTotalThreads);
        setPurchasedThreads(updatedPurchasedThreads);
        const remaining = Math.max(
          0,
          6000 + updatedPurchasedThreads - updatedTotalThreads
        );
        setRemainingConversations(remaining);

        if (remaining <= 0) {
          setIsLimitReached(true);
          setIsAutoResponseEnabled(false);
          setShowConversationLimitModal(true);
        } else {
          setIsLimitReached(false);
        }

        if (typeof userData.globalAutoResponseEnabled === 'boolean') {
          setGlobalAutoResponseEnabled(userData.globalAutoResponseEnabled);
        } else {
          setGlobalAutoResponseEnabled(true);
        }
      }
    });
    return () => unsubscribeUser();
  }, [currentUser]);

  // Cargar equipo
  useEffect(() => {
    if (!currentUser) return;
    const fetchTeamMembers = async () => {
      try {
        const userRef = doc(db, 'users', currentUser.uid);
        const userDocSnap = await getDoc(userRef);
        if (!userDocSnap.exists()) return;

        const userData = userDocSnap.data();
        const equipoMembers = userData.equipo || [];
        let mktMembers = [];

        if (userData.accessCode === 'MKT') {
          const mktQuery = query(
            collection(db, 'users'),
            where('accessCode', '==', 'MKT')
          );
          const mktSnap = await getDocs(mktQuery);
          mktMembers = mktSnap.docs
            .filter((snap) => snap.exists())
            .map((snap) => {
              const data = snap.data();
              if (data.nombre && data.apellido) {
                return {
                  id: snap.id,
                  type: 'real',
                  nombre: data.nombre,
                  apellido: data.apellido,
                  cargo: data.cargo || '',
                };
              } else if (data.name) {
                const nameParts = data.name.trim().split(' ');
                const nombre = nameParts[0];
                const apellido = nameParts.slice(1).join(' ') || '';
                return {
                  id: snap.id,
                  type: 'real',
                  nombre,
                  apellido,
                  cargo: data.cargo || '',
                };
              }
              return {
                id: snap.id,
                type: 'real',
                nombre: '',
                apellido: '',
                cargo: '',
              };
            });
        }

        const combinedTeamMembers = [
          ...equipoMembers.map((member, index) => ({
            id: `member${index}`,
            type: 'fictitious',
            nombre: member.nombre,
            apellido: member.apellido,
            cargo: member.cargo,
          })),
          ...mktMembers,
        ];

        setTeamMembers(combinedTeamMembers);
      } catch (error) {
        console.error('Error al cargar miembros del equipo:', error);
      }
    };
    fetchTeamMembers();
  }, [currentUser]);

  // Cargar columnas CRM
  useEffect(() => {
    if (!currentUser) return;
    const crmQuery = query(
      collection(db, 'crm'),
      where('authorizedUsers', 'array-contains', currentUser.uid)
    );
    const unsubscribe = onSnapshot(
      crmQuery,
      (snapshot) => {
        const columns = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setCrmColumns(columns);
      },
      (error) => {
        console.error('Error en listener de CRM:', error);
      }
    );
    return () => unsubscribe();
  }, [currentUser]);

  // Obtener Agents + redirección
  useEffect(() => {
    async function fetchAgentsAndHandleNavigation() {
      if (!currentUser) {
        setLoadingAgents(false);
        return;
      }
      try {
        const assistantsData = await getAllAssistants(currentUser.uid);
        setAgents(assistantsData);
        if (assistantsData.length === 0) {
          setNoAgents(true);
          setLoadingAgents(false);
          return;
        }
        setNoAgents(false);

        if (!assistantId && assistantsData.length > 0 && !isTeamRoute) {
          // Redirige al primer asistente que exista
          navigate(`/messages/${assistantsData[0].id}`);
        } else {
          // Buscar el agent si no es Team
          if (!isTeamRoute) {
            const agent = assistantsData.find((a) => a.id === assistantId);
            if (agent) {
              setSelectedAgent(agent);
            } else {
              console.error('assistantId inválido');
              setSelectedAgent(null);
              setSelectedThread(null);
              navigate('/messages');
            }
          }
        }
      } catch (error) {
        console.error('Error al obtener agentes:', error);
      }
      setLoadingAgents(false);
    }
    fetchAgentsAndHandleNavigation();
  }, [assistantId, currentUser, navigate, isTeamRoute]);

  // *** EL useEffect CRÍTICO: filtrar según “team-” o assistant ***
  useEffect(() => {
    if (!currentUser) return;

    // Si no hay un assistantId en la URL, vaciamos la lista de hilos y salimos
    if (!assistantId) {
      setThreads([]);
      return;
    }

    let cleanup = () => {};

    if (isTeamRoute) {
      if (!teamMembers || teamMembers.length === 0) {
        setLoadingThreads(true);
        return;
      }

      let aborted = false;
      const loadTeamThreads = async () => {
        setLoadingThreads(true);
        try {
          const all = await getAllAssistants(currentUser.uid);
          const theMember = teamMembers.find((m) => m.id === teamMemberUniqueId);
          if (!theMember) return;

          const ownerName = `${theMember.nombre} ${theMember.apellido}`.trim();
          const promises = all.map(async (assistant) => {
            const colRef = collection(db, `threads_${assistant.id}`);
            const q2 = query(colRef, where('conversationowner', '==', ownerName));
            const snap = await getDocs(q2);
            return snap.docs.map((docSnap) => ({
              threadId: docSnap.id,
              ...docSnap.data(),
              assistantId: assistant.id,
            }));
          });

          const arrayOfArrays = await Promise.all(promises);
          if (aborted) return;
          const combined = arrayOfArrays
            .flat()
            .sort((a, b) => {
              const aLast = new Date(a?.messageHistory?.at?.(-1)?.createdAt || 0);
              const bLast = new Date(b?.messageHistory?.at?.(-1)?.createdAt || 0);
              return bLast - aLast;
            });

          setThreads(combined);
        } catch (err) {
          if (!aborted) console.error('Error al cargar hilos de equipo:', err);
        } finally {
          if (!aborted) setLoadingThreads(false);
        }
      };

      loadTeamThreads();
      cleanup = () => {
        aborted = true;
      };
    } else {
      setLoadingThreads(true);
      const colRef = collection(db, `threads_${assistantId}`);
      const firstQ = buildFilteredQuery(colRef, {
        startDate     : filterStartDate,
        endDate       : filterEndDate,
        onlyUnread    : showOnlyUnread,
        onlyFavorites : filter === 'favorites',
        pageSize      : PAGE_SIZE,
        afterDoc      : null,
      });

const unsubscribe = onSnapshot(
  firstQ,
  (snap) => {
    const loaded = snap.docs.map((d) => ({
      threadId: d.id,
      ...d.data(),
      assistantId,
    }));

    // 👇 NO pisamos lo que ya había (páginas viejas), lo fusionamos
    setThreads((prev) => mergeThreadsLists(prev, loaded));

    // El lastDoc sigue siendo el último de la primera página
    setLastDoc(snap.docs[snap.docs.length - 1] || null);
    setHasMore(snap.size === PAGE_SIZE);
    setLoadingThreads(false);
  },
  (error) => {
    console.error('Error cargando hilos:', error);
    setLoadingThreads(false);
  }
);


      cleanup = () => unsubscribe();
    }

    if (teamMembers && teamMembers.length > 0 && teamMemberUniqueId) {
      const matching = teamMembers.find((m) => m.id === teamMemberUniqueId);
      if (matching && matching.id !== selectedTeamMember?.id) {
        setSelectedTeamMember(matching);
      }
    }

    return cleanup;
  }, [
    assistantId,
    isTeamRoute,
    teamMembers,
    teamMemberUniqueId,
    selectedTeamMember,
    setSelectedTeamMember,
    filterStartDate,
    filterEndDate,
    showOnlyUnread,
    filter,
    activeTags.length,
  ]);

  
async function loadMoreThreads() {
  if (!hasMore || loadingMore || !lastDoc) return;

  setLoadingMore(true);
  try {
// ── en loadMoreThreads:
const colRef = collection(db, `threads_${assistantId}`);

const nextQ = buildFilteredQuery(colRef, {
  startDate     : filterStartDate,
  endDate       : filterEndDate,
  onlyUnread    : showOnlyUnread,
  onlyFavorites : filter === 'favorites',
  pageSize      : PAGE_SIZE,
  afterDoc      : lastDoc,
});

const snap = await getDocs(nextQ);
const newThreads = snap.docs.map(d => ({
  threadId: d.id,
  ...d.data(),
  assistantId
}));
setThreads((prev) => mergeThreadsLists(prev, newThreads));
setLastDoc(snap.docs[snap.docs.length - 1] || null);
setHasMore(snap.size === PAGE_SIZE);

  } catch (err) {
    console.error('Error paginando threads:', err);
  } finally {
    setLoadingMore(false);
  }
}


// Escucha el doc del asistente actual para leer chatscount
useEffect(() => {
  // En vista “team-...” no mostramos el contador por asistente
  if (!assistantId || isTeamRoute) {
    setAssistantChatsCount(0);
    return;
  }

  const assistantRef = doc(db, 'assistants', assistantId);
  const unsub = onSnapshot(assistantRef, (snap) => {
    if (snap.exists()) {
      setAssistantChatsCount(snap.data()?.chatscount ?? 0);
    } else {
      setAssistantChatsCount(0);
    }
  });

  return () => unsub();
}, [assistantId, isTeamRoute]);


// =====================
// A) VERSIÓN REFETCH MANUAL
// =====================
/**
 * loadTeamThreadsRefetch:
 *  - Copia exacta del bloque que tienes en el useEffect
 *  - Para que puedas llamarla manualmente
 */
async function loadTeamThreadsRefetch() {
  if (!currentUser) return;
  if (!teamMembers || teamMembers.length === 0) return;
  if (!teamMemberUniqueId) return;

  setLoadingThreads(true);
  try {
    // Obtener todos los asistentes del usuario
    const all = await getAllAssistants(currentUser.uid);

    // Buscar el miembro en el array teamMembers
    const theMember = teamMembers.find((m) => m.id === teamMemberUniqueId);
    if (!theMember) {
      setLoadingThreads(false);
      return;
    }

    // Nombre completo del propietario
    const ownerName = `${theMember.nombre} ${theMember.apellido}`.trim();

    // Cargar en paralelo los threads de cada asistente filtrando por conversationowner
    const promises = all.map(async (assistant) => {
      const colRef = collection(db, `threads_${assistant.id}`);
      const q2 = query(colRef, where('conversationowner', '==', ownerName));
      const snap = await getDocs(q2);
      return snap.docs.map((docSnap) => ({
        threadId: docSnap.id,
        ...docSnap.data(),
        assistantId: assistant.id,
      }));
    });

    // Esperamos a que terminen todas las promesas y unificamos
    const arrayOfArrays = await Promise.all(promises);
    let combined = arrayOfArrays.flat();

    // Ordenar por fecha de último mensaje descendente
    combined.sort((a, b) => {
      const aLast = new Date(a?.messageHistory?.at?.(-1)?.createdAt || 0);
      const bLast = new Date(b?.messageHistory?.at?.(-1)?.createdAt || 0);
      return bLast - aLast;
    });

    // Guardar en el estado local
    setThreads(combined);
  } catch (err) {
    console.error('Error al cargar hilos de equipo (refetch):', err);
  } finally {
    setLoadingThreads(false);
  }
}


  // Cuando NO hay threadId, limpiamos el thread seleccionado
  // y mostramos la lista en mobile.
  useEffect(() => {
    if (threadId) {
      // Si ya se han cargado los threads y no se ha seleccionado ninguno,
      // buscamos el thread cuyo ID coincide con el de la URL
      if (threads.length > 0 && !selectedThread) {
        const foundThread = threads.find((t) => t.threadId === threadId);
        if (foundThread) {
          setSelectedThread(foundThread);
        }
      }
    } else {
      setSelectedThread(null);
      if (windowWidth <= 1000) {
        setShowMobileThreadList(true);
      }
    }
  }, [threadId, windowWidth, threads, selectedThread]);

  // ============ RESETEAR templateCountNoReply24h AL DETECTAR RESPUESTA O +24H =============
  useEffect(() => {
    if (!selectedThread) return;

    // Tomar el último mensaje
    const lastMsgLocal =
      selectedThread?.messageHistory?.[selectedThread.messageHistory.length - 1];

    if (lastMsgLocal?.role === 'user') {
      // El usuario respondió
      if ((selectedThread.templateCountNoReply24h || 0) > 0) {
        resetTemplateCountNoReply(selectedThread);
      }
      return;
    }

    // Si ya pasó 1 día desde la última plantilla => reset
    if (selectedThread.lastTemplateAt) {
      const now = Date.now();
      const lastTpl = new Date(selectedThread.lastTemplateAt).getTime();
      const diff = now - lastTpl;
      if (diff > 24 * 60 * 60 * 1000) {
        if ((selectedThread.templateCountNoReply24h || 0) > 0) {
          resetTemplateCountNoReply(selectedThread);
        }
      }
    }
  }, [selectedThread?.messageHistory]);

  const handleToggleTeamMember = async (member) => {
    if (!selectedThread) {
    toast.error('❌ No se ha seleccionado un thread');
      return;
    }
  
    if (selectedThread.conversationownerId === member.id) {
      // Ya está asignado a ese miembro => desasignar
      try {
        await updateDoc(
          doc(db, `threads_${selectedThread.assistantId}`, selectedThread.threadId),
          {
            conversationownerId: null,
            conversationowner: null,
          }
        );
        toast.success(`✔️ ¡Conversación desasignada de ${member.nombre} ${member.apellido}!`);
      } catch (error) {
        console.error('Error al desasignar conversación:', error);
        toast.error('❌ Hubo un error al desasignar.');
      } finally {
        // IMPORTANTE: hacer “refetch” para ver el cambio reflejado
        if (isTeamRoute) {
          loadTeamThreadsRefetch();
        }
        // Y si justo es el thread en el que estoy parado => actualizo local
        if (selectedThread.conversationownerId === member.id) {
          setSelectedThread((prev) =>
            prev ? { ...prev, conversationownerId: null, conversationowner: null } : null
          );
        }
      }
    } else {
      // Asignar a "member"
      const conversationOwnerName = `${member.nombre} ${member.apellido}`.trim();
      try {
        await updateDoc(
          doc(db, `threads_${selectedThread.assistantId}`, selectedThread.threadId),
          {
            conversationownerId: member.id,
            conversationowner: conversationOwnerName,
          }
        );
        toast.success(`✔️ Conversación asignada a ${conversationOwnerName}.`);
      } catch (error) {
        console.error('Error al asignar conversación:', error);
        toast.error('❌ Hubo un error al asignar.');
      } finally {
        // IMPORTANTE: recargar la lista
        if (isTeamRoute) {
          loadTeamThreadsRefetch();
        }
        // Actualiza también si es el hilo seleccionado
        if (selectedThread.conversationownerId !== member.id) {
          setSelectedThread((prev) =>
            prev
              ? {
                  ...prev,
                  conversationownerId: member.id,
                  conversationowner: conversationOwnerName,
                }
              : null
          );
        }
      }
    }
  };
  
  

  // Función para resetear el campo a 0
  const resetTemplateCountNoReply = async (thread) => {
    try {
      // 1) Actualizar la DB
      const ref = doc(db, `threads_${thread.assistantId}`, thread.threadId);
      await updateDoc(ref, {
        templateCountNoReply24h: 0,
      });

      // 2) Actualizar local
      setSelectedThread((prev) => {
        if (!prev) return prev;
        if (prev.threadId !== thread.threadId) return prev;
        return {
          ...prev,
          templateCountNoReply24h: 0,
        };
      });
    } catch (err) {
      console.error('Error reseteando templateCountNoReply24h:', err);
    }
  };



  // =============== MANEJADORES DE ACCIONES ===============

  // Cuando el usuario hace click en un thread
  const handleThreadClick = (thread) => {
    setHasManuallySelectedThread(true);

    if (isTeamRoute) {
      // Si la ruta actual es team-..., navegamos a la misma ruta team
      // conservando "teamMemberUniqueId" y agregando "/threadId"
      navigate(`/messages/team-${teamMemberUniqueId}/${thread.threadId}`);
    } else {
      // Caso normal (assistant route)
      navigate(`/messages/${thread.assistantId}/${thread.threadId}`);
    }

    // Seleccionar el thread
    handleSelectThread(thread);

    // En mobile, ocultar la lista
    if (windowWidth <= 1000) setShowMobileThreadList(false);
  };

  // Al seleccionar un thread (desde fetch / navigation)
  const handleSelectThread = async (thread) => {
    setSelectedThread(thread);
    setIsAutoResponseEnabled(thread.autoResponseEnabled ?? true);
    setScrollOnLoad(true); // <-- Activamos el "scroll al abrir"
    setIsUserNearBottom(true);

    // Remover el thread de la lista local de no leídos
    setUnreadThreadIds((prevIds) => prevIds.filter((id) => id !== thread.threadId));

    // Feedback inmediato en UI + persistencia
    markThreadAsRead(thread);
  };
  useEffect(() => {
  if (!selectedThread) return;

  const docRef = doc(
    db,
    `threads_${selectedThread.assistantId}`,
    selectedThread.threadId
  );

  const unsub = onSnapshot(docRef, snap => {
    if (!snap.exists()) return;
    // Mantén el assistantId y el threadId que ya tenías
    setSelectedThread(prev => ({
      ...snap.data(),
      assistantId: prev?.assistantId,
      threadId   : snap.id
    }));
  });

  return unsub;          // limpia al desmontar / al cambiar de thread
}, [selectedThread?.assistantId, selectedThread?.threadId]);

// 1) Determinar el docId según accessCode
function getTrackingDocId(userData, currentUser) {
  // Si tiene un accessCode NO vacío => usarlo
  if (userData?.accessCode) {
    return userData.accessCode;  
  } 
  // Si no => usar el UID
  return currentUser.uid;
}
// 1) Definir el array de frases genéricas por defecto
const DEFAULT_RECONTACT_PHRASES = [
  "¡Hola! Seguimos en línea para proporcionarte la información que precises",
  "Su consulta es importante para nosotros. ¿Cómo podemos asistirle?",
  "¿Te ha resultado útil lo que conversamos? Quedamos atentos a cualquier consulta adicional.",
  "¡Buenas! ¿Necesitas más información o que revisemos algo en particular? Estamos para ayudarte.",
  "¿Pudiste ver mi último mensaje?",
  "¿Te fue posible revisar lo que te envié?",
  "¿Qué te pareció lo que conversamos hasta ahora?"
];

// fetchUserTrackingPhrases:
//    Carga el doc (trackingPhrases/docId).
//    Si no existe => se crea vacío.
// 2) Cuando creas/trayendo el doc de trackingPhrases
async function fetchUserTrackingPhrases() {
  if (!currentUser) return;

  const userRef = doc(db, 'users', currentUser.uid);
  const userSnap = await getDoc(userRef);
  if (!userSnap.exists()) return;
  const userData = userSnap.data();

  // docId según accessCode o uid
  const docId = getTrackingDocId(userData, currentUser); 
  const phrasesRef = doc(db, 'trackingPhrases', docId);
  const snap = await getDoc(phrasesRef);

  if (snap.exists()) {
    // Si existe, sacamos el array
    const existing = snap.data().phrases || [];

    // Opcional: si quieres fusionar las 5 por defecto con las existentes
    // (sin duplicar), podrías:
    const merged = [
      ...new Set([...existing, ...DEFAULT_RECONTACT_PHRASES]),
    ];

    // Guardamos el merged (por si hacen falta)
    if (merged.length !== existing.length) {
      // Solo si hay algo nuevo que guardar
      await updateDoc(phrasesRef, { phrases: merged });
      setTrackingPhrases(merged);
    } else {
      setTrackingPhrases(existing);
    }
  } else {
    // Si no existe => lo creamos con las frases por defecto
    await setDoc(phrasesRef, { phrases: DEFAULT_RECONTACT_PHRASES });
    setTrackingPhrases(DEFAULT_RECONTACT_PHRASES);
  }
}

// addTrackingPhrase:
//    Agrega la frase al doc (trackingPhrases/docId) usando setDoc(merge:true)
async function addTrackingPhrase(newPhrase) {
  if (!currentUser) return;
  try {
    // 1) Volver a buscar el user para saber si tiene accessCode
    const userRef = doc(db, 'users', currentUser.uid);
    const userSnap = await getDoc(userRef);
    if (!userSnap.exists()) return;
    const userData = userSnap.data();

    // 2) docId según accessCode o uid
    const docId = getTrackingDocId(userData, currentUser);

    // 3) Hacer setDoc con merge:true
    const docRef = doc(db, 'trackingPhrases', docId);
    await setDoc(
      docRef,
      { phrases: arrayUnion(newPhrase) },
      { merge: true }
    );

    // 4) Recargar
    await fetchUserTrackingPhrases();
  } catch (error) {
    console.error('Error al guardar la nueva frase:', error);
  }
}

// 1) Función para eliminar una frase
async function removeTrackingPhrase(phraseToRemove) {
  if (!currentUser) return;

  try {
    // 1) Obtener tu docId (igual que en addTrackingPhrase)
    const userRef = doc(db, 'users', currentUser.uid);
    const userSnap = await getDoc(userRef);
    if (!userSnap.exists()) return;
    const userData = userSnap.data();

    const docId = getTrackingDocId(userData, currentUser);

    // 2) Hacer updateDoc con arrayRemove
    const docRef = doc(db, 'trackingPhrases', docId);
    await updateDoc(docRef, {
      phrases: arrayRemove(phraseToRemove),
    });

    // 3) Volver a cargar la lista local
    await fetchUserTrackingPhrases();
  } catch (error) {
    console.error('Error al eliminar frase de seguimiento:', error);
  }
}

  // Manejo de asignar TeamMember
  const handleSelectTeamMember = async (member) => {
    // Verificamos que sí haya un thread
    if (!selectedThread) {
    toast.error('❌ No se ha seleccionado un thread.');
      return;
    }
  
    // Tomamos el assistantId del thread
    const finalAssistantId = selectedThread.assistantId;
    if (!finalAssistantId) {
      toast.error('❌ El thread no tiene assistantId, no se puede asignar.');
      return;
    }
  
    if (!member.id) {
      toast.error('❌ Error interno: el miembro no tiene un ID válido.');
      return;
    }
  
    const conversationOwnerName = `${member.nombre} ${member.apellido}`.trim();
  
    try {
      // Asignar propietario en Firestore
      const threadRef = doc(db, `threads_${finalAssistantId}`, selectedThread.threadId);
      await updateDoc(threadRef, {
        conversationownerId: member.id,
        conversationowner: conversationOwnerName,
      });
  
      // Si SÍ estamos en ruta "team-...", hace el navigate; si NO, solo avisa.
      if (isTeamRoute) {
        // O sea, assistantId empieza con "team-"
        navigate(`/messages/team-${member.id}/${selectedThread.threadId}`);
       toast.success(`✔️ Conversación asignada a ${conversationOwnerName}. Redirigiendo...`);
      } else {
        // Caso normal: no hace navigate
        // Actualizamos el estado local, si queremos
        setSelectedThread({
          ...selectedThread,
          conversationownerId: member.id,
          conversationowner: conversationOwnerName,
        });
        toast.success(`✔️ Conversación asignada a ${conversationOwnerName}. (sin navegación)`);
      }
    } catch (error) {
      console.error('Error asignando conversationowner:', error);
      toast.error('❌ Error al asignar conversación.');
    } finally {
      setIsTeamModalOpen(false);
    }
  };
  
  async function doForceTrackingToggle(activate, phrase) {
    if (!selectedThread) return;
    try {
      const threadRef = doc(
        db,
        `threads_${selectedThread.assistantId}`,
        selectedThread.threadId
      );
      await updateDoc(threadRef, {
        trackingActive: activate,
        trackingPhrase: phrase,
      });
  
      // Actualizamos el estado local de selectedThread
      setSelectedThread((prev) => {
        if (!prev) return prev;
        return {
          ...prev,
          trackingActive: activate,
          trackingPhrase: phrase,
        };
      });
  
      if (activate) {
        toast.success(`✔️ Seguimiento activado con la frase: "${phrase}"`);
      } else {
        toast.info('ℹ️ Seguimiento desactivado');
      }
    } catch (error) {
      console.error('Error al forzar tracking:', error);
    }
  }
  

  // ====================================================
  // Filtrado y ordenamiento basado en threads
  // ====================================================
function applyFiltersAndOrder(
source,
  { filter, filterStartDate, filterEndDate, showOnlyUnread, orderBy, activeTags }
) {
 let list = [...source];

  // ■ Etiquetas (filtrado cliente)
if (activeTags.length) {
  const norm = s => String(s || '').trim().toLowerCase();
  const active = new Set(activeTags.map(norm));

  list = list.filter(t => {
    const tags = Array.isArray(t.etiquetas) ? t.etiquetas : [];
    return tags.some(e => {
      // e puede ser "seguimiento" o { nombre:"seguimiento", color:"#..." } o { name:"seguimiento" }
      const nombre = typeof e === 'string' ? e : (e.nombre ?? e.name ?? '');
      return active.has(norm(nombre));
    });
  });
}


  // ■ Favoritos
  if (filter === 'favorites') {
    list = list.filter(t => t.isFavorite);
  }

  // ■ Pendientes
  if (showOnlyUnread) {
    list = list.filter(t => !t.readByUser);
  }

  // ■ Fecha (opcional: ya vino filtrada servidor, pero puedes ajustar aquí también)
  if (filterStartDate || filterEndDate) {
    list = list.filter(t => {
      const d = new Date(t?.messageHistory?.at?.(-1)?.createdAt || 0);
      if (filterStartDate && d < new Date(`${filterStartDate}T00:00:00`)) return false;
      if (filterEndDate   && d > new Date(`${filterEndDate}T23:59:59.999`)) return false;
      return true;
    });
  }


    // 'date' o 'lastMessage'
    list.sort((a, b) => {
      const A = new Date(a?.messageHistory?.at?.(-1)?.createdAt || 0);
      const B = new Date(b?.messageHistory?.at?.(-1)?.createdAt || 0);
      return B - A;
    });
  

  return list;
}

// ═══════════════════════════════════════════════════════════════════════════
// LÓGICA DE FILTROS OPTIMIZADA
// - Filtros server-side (favoritos, no leídos, fechas): usan `threads` directo
// - Filtros por etiquetas: requieren `allThreads` (carga paginada)
// - Búsqueda global: requiere `allThreads`
// ═══════════════════════════════════════════════════════════════════════════

// Filtros que Firestore NO puede manejar (requieren cargar todo)
const hasTagFilter = activeTags.length > 0;

// Todos los filtros activos (para mostrar indicador visual)
const anyFilterActive =
  showOnlyUnread ||
  filter === 'favorites' ||
  !!filterStartDate ||
  !!filterEndDate ||
  hasTagFilter;

const finalDisplayedThreads = useMemo(() => {
  let source;

  if (isGlobalSearchOpen) {
    // Búsqueda global: usar resultados de búsqueda o allThreads
    source = globalSearchTerm.trim()
      ? globalSearchResults
      : (allThreads ?? threads);
  } else if (hasTagFilter) {
    // Filtro por etiquetas: NECESITA allThreads (carga paginada)
    // Mientras carga, usa threads como fallback
    source = allThreads ?? threads;
  } else {
    // Sin filtros por etiquetas: usar threads directo
    // (favoritos, no leídos, fechas ya vienen filtrados del servidor)
    source = threads;
  }

  return applyFiltersAndOrder(source, {
    filter,
    filterStartDate,
    filterEndDate,
    showOnlyUnread,
    orderBy,
    activeTags
  });
}, [
  allThreads,
  threads,
  isGlobalSearchOpen,
  globalSearchResults,
  globalSearchTerm,
  filter,
  filterStartDate,
  filterEndDate,
  showOnlyUnread,
  orderBy,
  activeTags,
  hasTagFilter,
]);

// ⬇️ Core delete SIN confirmación (reutilizable)
const deleteThreadPermanently = async (tId, { silent = false } = {}) => {
  const thread = findThreadById(tId);
 if (!thread) return;
 try {
   // 1) Feedback inmediato: eliminar de todos los estados locales (sin esperar Firebase)
   setThreads(prev => prev.filter(t => t.threadId !== tId));
   setAllThreads(prev => Array.isArray(prev) ? prev.filter(t => t.threadId !== tId) : prev);
   setGlobalSearchResults(prev => Array.isArray(prev) ? prev.filter(t => t.threadId !== tId) : prev);
   
   setSelectedIds(prev => {
     const next = new Set(prev);
     next.delete(tId);
     return next;
   });

   if (selectedThread?.threadId === tId) {
     setSelectedThread(null);
   }

   // 2) Persistir en Firebase (en segundo plano, no bloquea UI)
   await deleteDoc(doc(db, `threads_${thread.assistantId}`, tId));

   // 3) Decrementar contador del asistente
   await updateDoc(doc(db, 'assistants', thread.assistantId), {
     chatscount: increment(-1),
    });

   // 4) Invalidar caché
    invalidateAllThreadsCache(thread.assistantId);

   if (!silent) toast.success('✔️ Chat eliminado.');
 } catch (error) {
   console.error('Error al eliminar chat o actualizar contador:', error);
    if (!silent) toast.error('❌ Error al eliminar chat.');
  }
};

// Borrado individual CON confirmación
const handleDeleteThread = async (tId) => {
  const thread = findThreadById(tId);
  if (!thread) return;
  const ok = window.confirm('¿Seguro de eliminar este chat?');
  if (!ok) return;
  await deleteThreadPermanently(tId, { silent: false });
};



const heightSignature = useMemo(
  () =>
    finalDisplayedThreads
      .map((t) => `${t.threadId}:${t.etiquetas?.length || 0}`)
      .join('|'),
  [finalDisplayedThreads]
);

useEffect(() => {
  // Recalcula alturas pero SIN resetear el scroll
  if (listRef.current) {
    listRef.current.resetAfterIndex(0, false);
  }
}, [heightSignature]);


  // Toggle favorito
// Toggle favorito
const toggleFavorite = async (tId) => {
  const thread = threads.find((t) => t.threadId === tId);
  if (!thread) return;

  const ref = doc(db, `threads_${thread.assistantId}`, tId);
  try {
    const newValue = !(thread.isFavorite ?? false);
    await updateDoc(ref, { isFavorite: newValue });

    // ⭐ ACTUALIZAR STATE LOCAL ──> feedback inmediato
    setThreads((prev) =>
      prev.map((t) =>
        t.threadId === tId ? { ...t, isFavorite: newValue } : t
      )
    );

    // Si tenés un thread seleccionado y es el mismo, actualizalo también
    setSelectedThread((prev) =>
      prev && prev.threadId === tId ? { ...prev, isFavorite: newValue } : prev
    );

    // Para que la ruta team mantenga consistencia con Firestore
    if (isTeamRoute) {
      // opcional: recargar desde la BD para asegurar orden correcto
      // await loadTeamThreadsRefetch();
    }
  } catch (err) {
    console.error('Error al cambiar favorito:', err);
  }
};

// Rango a mostrar (1–50), o 0–0 si no hay hilos
// Rango mostrado (dinámico según la página cargada)
const rangeLabel = useMemo(() => {
  if (isTeamRoute) return '';

  // ¿Hay filtros activos?
  const anyFilterActive =
    showOnlyUnread ||
    filter === 'favorites' ||
    !!filterStartDate ||
    !!filterEndDate ||
    activeTags.length > 0;

  // ✅ Con filtros (o búsqueda global): mostrar SOLO el total resultante del filtro
  if (anyFilterActive || isGlobalSearchOpen) {
    const n = finalDisplayedThreads.length;
    return `${n} chat${n === 1 ? '' : 's'}`;
  }

  // 🔁 Sin filtros: mantener el comportamiento 1–N de TOTAL (de Firestore)
  const total = assistantChatsCount || 0;
  const loaded = threads.length;
  if (loaded === 0) return `0-0 de ${total}`;
  const end = Math.min(loaded, total);
  return `1-${end} de ${total}`;
}, [
  isTeamRoute,
  showOnlyUnread,
  filter,
  filterStartDate,
  filterEndDate,
  activeTags.length,
  isGlobalSearchOpen,
  finalDisplayedThreads.length,
  assistantChatsCount,
  threads.length,
]);

  // Manejo de “Mover a columna CRM”
  const handleMoveToColumn = async (thread, targetColumnId) => {
    if (!currentUser) return;
    try {
      const { messageHistory, ...threadWithoutMessages } = thread;
      const threadToMove = {
        ...threadWithoutMessages,
        createdAt: thread.createdAt || new Date().toISOString(),
      };
      const columnRef = doc(db, 'crm', targetColumnId);
      const columnSnap = await getDoc(columnRef);
      if (!columnSnap.exists()) {
        throw new Error('Columna no encontrada');
      }
      const columnData = columnSnap.data();
      const updatedThreads = [...(columnData.threads || [])];
      const threadIndex = updatedThreads.findIndex(
        (t) => t.threadId === threadToMove.threadId
      );
      if (threadIndex === -1) {
        updatedThreads.unshift(threadToMove);
      } else {
        updatedThreads[threadIndex] = threadToMove;
      }
      await updateDoc(columnRef, {
        threads: updatedThreads,
        lastUpdatedBy: currentUser.uid,
      });
      toast.success(`✔️Chat movido a ${columnData.name}`);
    } catch (error) {
      console.error('Error al mover thread:', error);
      toast.error('❌Error al mover chat.');
    } finally {
      setIsMoveMenuOpen(null);
    }
  };

  useEffect(() => {
    if (currentUser) {
      fetchUserTrackingPhrases();
    }
  }, [currentUser]);


const [showSummaryBox, setShowSummaryBox] = useState(false);
const [threadSummary, setThreadSummary] = useState('');
const [isSummarizing, setIsSummarizing] = useState(false);
const listRef = useRef(null);

const handleSummarizeThread = async () => {
  if (!selectedThread) return;

  try {
    // ¡Activamos el spinner!
    setIsSummarizing(true);

    const resp = await fetch('https://backend.thethingapp.com/api/summarize-thread', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        assistantId: selectedThread.assistantId,
        threadId: selectedThread.threadId
      })
    });

    const data = await resp.json();
    if (!data.success) {
      toast.error('❌ Error al generar resumen: ' + data.error);
      return;
    }

    setThreadSummary(data.summary);
    setShowSummaryBox(true); 

  } catch (err) {
    console.error('Error generando resumen:', err);
    toast.error('❌ Error generando resumen');
  } finally {
    // Quitamos el spinner
    setIsSummarizing(false);
  }
};

  

  const renderMoveDropdown = (thread) => {
    if (!isMoveMenuOpen || isMoveMenuOpen !== thread.threadId) return null;
    return (
      <div className="order-dropdown-messages">
        <div className="move-dropdown-content">
          {crmColumns.map((column) => (
            <div
              key={column.id}
              className="move-option"
              onClick={() => handleMoveToColumn(thread, column.id)}
            >
              {column.name}
            </div>
          ))}
        </div>
      </div>
    );
  };

  // Manejo de archivos
  const handleFileIconClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setSelectedFiles(files);
    const newPreviews = files.map((file) => {
      if (file.type.startsWith('image/')) {
        return {
          type: 'image',
          url: URL.createObjectURL(file),
          name: file.name,
        };
      }
      if (file.type.startsWith('video/')) {
        return {
          type: 'video',
          url: URL.createObjectURL(file),
          name: file.name,
        };
      }
      if (file.type.startsWith('audio/')) {
        return {
          type: 'audio',
          url: URL.createObjectURL(file),
          name: file.name,
        };
      }
      return { type: 'document', url: URL.createObjectURL(file), name: file.name };
    });
    setPreviewURLs(newPreviews);
      e.target.value = ''
  };

  const openPreviewModal = (index) => {
    setCurrentPreviewIndex(index);
    setIsModalOpen(true);
  };
  const closePreviewModal = () => {
    setIsModalOpen(false);
  };

  const handleRemoveFile = (index) => {
    const updatedFiles = [...selectedFiles];
    updatedFiles.splice(index, 1);
    setSelectedFiles(updatedFiles);
    const updatedPreviews = [...previewURLs];
    updatedPreviews.splice(index, 1);
    setPreviewURLs(updatedPreviews);
  };

  // Manejador del input de búsqueda local
  const handleSearch = (term) => {
    setSearchTerm(term);
  };
// =============================
// Manejador de Búsqueda Global
// =============================
const handleGlobalSearch = async () => {
  const term = globalSearchTerm.trim().toLowerCase();

  // Sin término: limpiar resultados y apagar spinner
  if (!term) {
    setGlobalSearchResults([]);
    setIsGlobalSearchLoading(false);
    return;
  }

  // Aún no está construído el índice (allThreads):
  // dejá que el otro effect lo cargue; no toques el spinner acá.
  const hasIndex = !!(allThreads && allThreads.length);

  if (hasIndex) setIsGlobalSearchLoading(true);
  try {
// si aún no tenemos allThreads, buscamos en los primeros 50 (threads)
const source = hasIndex ? allThreads : threads;
    const matching = source.filter((th) => {
      // 1) Buscar en los mensajes
      const foundInMessages = (th.messageHistory || []).some((m) =>
        String(m?.content || '').toLowerCase().includes(term)
      );

      // 2) Buscar en el nombre del contacto
      const foundInSenderName = String(th.senderName || '')
        .toLowerCase()
        .includes(term);

      // 3) Buscar en el phoneNumber
      const foundInPhoneNumber = String(th.phoneNumber || '')
        .toLowerCase()
        .includes(term);

      // 4) Buscar en userName (si existiera)
      const foundInUserName = String(th.userName || '')
        .toLowerCase()
        .includes(term);

      return (
        foundInMessages ||
        foundInSenderName ||
        foundInPhoneNumber ||
        foundInUserName
      );
    });

    setGlobalSearchResults(matching);
  } catch (error) {
    console.error('Error en búsqueda global:', error);
  } finally {
    if (hasIndex) setIsGlobalSearchLoading(false);
  }
};

// =======================================================
// Disparador: reacciona a cambios del término/índice/open
// =======================================================
useEffect(() => {
  if (!isGlobalSearchOpen) return;

  const hasTerm = !!globalSearchTerm.trim();
  if (!hasTerm) {
    setIsGlobalSearchLoading(false);
    setGlobalSearchResults([]);
    return;
  }

  // Mientras no tengamos todo el índice, marcamos que seguimos buscando,
  // pero igual mostramos resultados parciales (de threads).
  setIsGlobalSearchLoading(!(allThreads && allThreads.length));

  handleGlobalSearch(); // ahora busca en allThreads ?? threads
}, [globalSearchTerm, isGlobalSearchOpen, allThreads, threads]);


const handleCloseGlobalSearch = () => {
  // invalida cualquier ciclo en curso
  allThreadsRunIdRef.current++;

  setIsGlobalSearchOpen(false);
  setGlobalSearchTerm('');
  setGlobalSearchResults([]);
  setIsGlobalSearchLoading(false);
};

  // Búsqueda dentro del thread
  const handleMessageSearch = () => {
    if (!searchQuery.trim()) return;
    const lowerCaseQuery = searchQuery.toLowerCase();
    const results = [];
    selectedThread.messageHistory.forEach((message, i) => {
      if (message.content.toLowerCase().includes(lowerCaseQuery)) {
        results.push(i);
      }
    });
    if (results.length > 0) {
      setSearchResults(results);
      setCurrentSearchIndex(0);
      const firstIndex = results[0];
      if (messageRefs.current[firstIndex]) {
        messageRefs.current[firstIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    } else {
     toast.info('ℹ️ No se encontró el término de búsqueda');
      setSearchResults([]);
      setCurrentSearchIndex(0);
    }
  };

  const goToNextSearchResult = () => {
    if (searchResults.length === 0) return;
    const nextIndex = (currentSearchIndex + 1) % searchResults.length;
    setCurrentSearchIndex(nextIndex);
    const msgIndex = searchResults[nextIndex];
    if (messageRefs.current[msgIndex]) {
      messageRefs.current[msgIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  };

  const goToPreviousSearchResult = () => {
    if (searchResults.length === 0) return;
    const prevIndex =
      (currentSearchIndex - 1 + searchResults.length) % searchResults.length;
    setCurrentSearchIndex(prevIndex);
    const msgIndex = searchResults[prevIndex];
    if (messageRefs.current[msgIndex]) {
      messageRefs.current[msgIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  };

  const prevMessageCountRef = useRef(selectedThread?.messageHistory?.length || 0);

  const currentAssistantThreads = useMemo(() => {
    return threads.filter((t) => t.assistantId === assistantId);
  }, [threads, assistantId]);

// CÓDIGO CORREGIDO Y FINAL
useEffect(() => {
  if (!selectedThread) return;

  // 1. Buscamos la versión más actualizada del hilo desde 'threads' (nuestra fuente de verdad de Firestore)
  const updatedThread = threads.find(
    (t) => t.threadId === selectedThread.threadId
  );

  if (!updatedThread) return;

  // 2. Obtenemos el último mensaje de ambos para compararlos
  const lastMessageInState = selectedThread?.messageHistory?.[selectedThread.messageHistory.length - 1];
  const lastMessageInProps = updatedThread?.messageHistory?.[updatedThread.messageHistory.length - 1];

  // 3. LA COMPARACIÓN CLAVE: Verificamos si el contenido o el estado del último mensaje cambió.
  //    Esto detecta la sobrescritura de 'sent' a 'failed'.
  //    Usamos JSON.stringify para una comparación segura y fácil de cualquier cambio en el objeto del mensaje.
  const lastMessageChanged = JSON.stringify(lastMessageInState) !== JSON.stringify(lastMessageInProps);

  // También mantenemos la comprobación de longitud por si se añaden o eliminan mensajes.
  const lengthChanged = (updatedThread?.messageHistory?.length || 0) !== (selectedThread?.messageHistory?.length || 0);

  // 4. Si la longitud cambió O el último mensaje fue modificado, actualizamos la UI.
  if (lengthChanged || lastMessageChanged) {
    setSelectedThread(updatedThread);
  }
  
}, [threads, assistantId]);


 // Función para alternar el tracking (trackingActive) a nivel de thread
// OJO: Ya NO hace directamente el updateDoc.
// Solo abre el modal, indicando que es “seguimiento individual”
// Donde ya tienes tu toggleThreadTracking
const toggleThreadTracking = () => {
  if (!selectedThread) {
    toast.info('ℹ️ No se ha seleccionado un thread.');
    return;
  }
  // Indicamos que es “toggle individual”
  setIsGlobalTrackingToggle(false);

  // 1) Si ya está activado, tomar la frase "trackingPhrase" y setearla como seleccionada
  if (selectedThread.trackingActive && selectedThread.trackingPhrase) {
    setSelectedTrackingPhrase(selectedThread.trackingPhrase);
  } else {
    // Si no, limpiamos (ninguna seleccionada)
    setSelectedTrackingPhrase('');
  }

  // Abrimos el modal
  setShowTrackingPhraseModal(true);
};





async function doIndividualTrackingToggle(chosenPhrase) {
  if (!selectedThread) return;
  const newTrackingValue = !selectedThread.trackingActive;

  try {
    const threadRef = doc(
      db,
      `threads_${selectedThread.assistantId}`,
      selectedThread.threadId
    );
    await updateDoc(threadRef, {
      trackingActive: newTrackingValue,
      trackingPhrase: chosenPhrase || '',
    });

    // Actualizamos estado local
    setSelectedThread((prev) =>
      prev ? { ...prev, trackingActive: newTrackingValue } : null
    );

toast.success(`✔️
      Seguimiento ${
        newTrackingValue ? 'activado' : 'desactivado'
      } con la frase: "${chosenPhrase}"`
    );
  } catch (error) {
    console.error('Error al actualizar tracking del thread:', error);
  }
}

useEffect(() => {
  function handleClickOutsideDropdowns(e) {
    // Si NO clickeaste dentro de ninguno de los dropdowns ni de sus toggles...
    if (
      !e.target.closest('.order-dropdown-messages') &&    // menús genéricos
      !e.target.closest('.move-dropdown-content') &&      // sub-menús (tags/CRM)
      !e.target.closest('.auto-menu-dropdown') &&         // menú IA
      !e.target.closest('.auto-menu-toggle') &&           // toggle IA
      !e.target.closest('.options-thread') &&             // botón “⋮” escritorio
      !e.target.closest('.options-thread-mobile')         // botón “⋮” mobile
    ) {
      setIsOrderDropdownOpen(false);
      setIsAutoMenuOpen(false);
      setHoveredCrmThreadId(null);
      closeAll();               // cierra CRM y etiquetas
      setIsMoveMenuOpen(null);  // **cierra el menú de opciones del thread**
    }
  }

  document.addEventListener('click', handleClickOutsideDropdowns);
  return () => {
    document.removeEventListener('click', handleClickOutsideDropdowns);
  };
}, [isOrderDropdownOpen, isAutoMenuOpen, isMoveMenuOpen]);


  // =================== PLANTILLAS ====================

  const checkIfTemplateExists = async () => {
    if (!selectedThread?.assistantId) return;
    setCheckingTemplate(true);
    try {
      const response = await fetch('https://backend.thethingapp.com/check-template', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ assistantId: selectedThread.assistantId }),
      });
      const data = await response.json();
      if (data.success) {
        setTemplateExists(data.exists);
      } else {
        console.error('Error al verificar plantilla:', data.error);
      }
    } catch (error) {
      console.error('Error en checkIfTemplateExists:', error);
    } finally {
      setCheckingTemplate(false);
    }
  };

  const createTemplate = async () => {
    if (!selectedThread?.assistantId) return;
    if (!window.confirm('¿Crear la plantilla "contacto"?')) return;
    setCreatingTemplate(true);
    try {
      const response = await fetch('https://backend.thethingapp.com/create-template', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ assistantId: selectedThread.assistantId }),
      });
      const data = await response.json();
      if (data.success) {
        toast.success('✔️Plantilla "Contacto" creada con éxito.');
        setTemplateExists(true);
      } else {
        console.error('Error al crear plantilla:', data.error);
        toast.error('❌ Error al crear plantilla');
      }
    } catch (error) {
      console.error('Error en createTemplate:', error);
      toast.error('❌ Hubo un error');
    } finally {
      setCreatingTemplate(false);
    }
  };

  // Ejemplo: Llamada repetida a tu endpoint “create-template” con nombre y body distinto.
  const createDefaultTemplates = async () => {
    if (!selectedThread?.assistantId) {
      toast.error('❌ No hay assistantId');
      return;
    }

    setIsCreatingDefaults(true);
    const defaultTemplates = [
      { name: 'tt_contacto', bodyText: '¡Hola!☺️ ¿Cómo estás?' },
      { name: 'tt_en_linea', bodyText: '¡Hola! Estamos en línea☺️' },
      { name: 'tt_que_necesitas', bodyText: '¡Hola! ¿Qué necesitas hoy?' },
      { name: 'tt_confirmar_recepcion', bodyText: '¿Te ha resultado posible revisar lo que te envié?' },
      { name: 'tt_necesitas_ayuda', bodyText: '¿Necesitas alguna aclaración o ayuda adicional? Quedo atento a tus comentarios.' },
    ];

    setCreatingTemplate(true);

    try {
      // Filtramos solo las plantillas que NO existan todavía
      const templatesToCreate = defaultTemplates.filter((tpl) =>
        !availableTemplates.some((existing) => existing.name === tpl.name)
      );

      for (const tpl of templatesToCreate) {
        await fetch('https://backend.thethingapp.com/create-template', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            assistantId: selectedThread.assistantId,
            name: tpl.name,
            bodyText: tpl.bodyText,
          }),
        });
      }

      toast.success('✔️ Se han creado las nuevas plantillas predeterminadas.');
      fetchAllTemplates();
    } catch (err) {
      console.error('Error al crear plantillas predeterminadas:', err);
      toast.error('❌ Error al crear plantillas predeterminadas');
    } finally {
      setIsCreatingDefaults(false);
    }
  };

  // Mapeo de nombre => texto
  const defaultBodyMap = {
    tt_contacto: '¡Hola!☺️ ¿Cómo estás?',
    tt_en_linea: '¡Hola! Estamos en línea☺️',
    tt_que_necesitas: '¡Hola! ¿Qué necesitas hoy?',
    tt_confirmar_recepcion: '¿Te ha resultado posible revisar lo que te envié?',
    tt_necesitas_ayuda:
      '¿Necesitas alguna aclaración o ayuda adicional? Quedo atento a tus comentarios.',
  };

  // Listar plantillas
  const fetchAllTemplates = async () => {
    if (!selectedThread?.assistantId) return;
    try {
      const response = await fetch('https://backend.thethingapp.com/list-templates', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ assistantId: selectedThread.assistantId }),
      });
      const data = await response.json();
      if (data.success && Array.isArray(data.templates)) {
        setAvailableTemplates(data.templates);
      } else {
        console.error('Error al obtener plantillas:', data.error);
      }
    } catch (error) {
      console.error('Error en fetchAllTemplates:', error);
    }
  };

  useEffect(() => {
    if (selectedThread) {
      checkIfTemplateExists();
      fetchAllTemplates();
    }
  }, [selectedThread]);

  // ============ Contador de plantillas sin respuesta <24h ============

  const incrementTemplateCountNoReply = async () => {
    if (!selectedThread) return;
    try {
      const threadRef = doc(
        db,
        `threads_${selectedThread.assistantId}`,
        selectedThread.threadId
      );
      const snap = await getDoc(threadRef);
      if (!snap.exists()) return;

      const data = snap.data();
      let currentCount = data.templateCountNoReply24h || 0;
      currentCount += 1;
      await updateDoc(threadRef, {
        templateCountNoReply24h: currentCount,
        lastTemplateAt: new Date().toISOString(),
      });
    } catch (error) {
      console.error('Error incrementando templateCountNoReply24h:', error);
    }
  };

// 2) Enviar la plantilla
// EN /src/components/ThreadsViewer.js

const handleSendTemplate = async (tplName = selectedTemplate) => {
  if (!selectedThread?.threadId || !selectedThread.phoneNumber) {
    toast.info('ℹ️ Falta información');
    return;
  }

  // Mostramos que estamos enviando, pero no hacemos ninguna otra actualización de estado.
  setIsSending(true); 

  try {
    const response = await fetch('https://backend.thethingapp.com/send-template', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        phoneNumber: selectedThread.phoneNumber,
        assistantId: selectedThread.assistantId,
        threadId: selectedThread.threadId,
        templateName: tplName,
        languageCode: 'es',
      }),
    });

    // No nos importa la respuesta. El webhook y onSnapshot son la única fuente de verdad.
    // Si la llamada falla a nivel de red, el catch lo manejará.
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || 'Error de red al enviar la plantilla');
    }

    markThreadAsRead(selectedThread);

  } catch (error) {
    console.error('Error en la llamada a handleSendTemplate:', error);
    toast.error('❌ ' + error.message);
  } finally {
    setIsSending(false);
    setNewMessage(''); // Limpiamos el input en cualquier caso.
    setChosenTemplate(null);
  }
};

  function isTemplateMessage(msg) {
    // Solo marcamos como plantilla si:
    // A) Es un mensaje enviado por 'assistant' (no por 'user')
    // B) Su ID arranca con 'wamid.'
    return (
      msg?.role === 'assistant' &&
      typeof msg?.id === 'string' &&
      msg.id.startsWith('wamid.')
    );
  }

  // 2) Función para obtener el último mensaje NO plantilla (de cualquier rol)
  function getLastNonTemplateMessage(messages) {
    if (!messages || messages.length === 0) return null;
    // Recorremos de atrás hacia adelante y descartamos mensajes de nota/alert
    for (let i = messages.length - 1; i >= 0; i--) {
      const m = messages[i];
      // Ignorar notas (o mensajes con messageType 'alert')
      if (m.role === 'nota' || m.messageType === 'alert') {
        continue;
      }
      if (!isTemplateMessage(m)) {
        return m;
      }
    }
    return null;
  }
  
  // =========== Enviar mensaje normal =============
  const getMessageType = (mimeType) => {
    if (mimeType.startsWith('image/')) return 'image';
    if (mimeType.startsWith('video/')) return 'video';
    if (mimeType.startsWith('audio/')) return 'audio';
    return 'document';
  };

  const MAX_FILE_SIZE = {
    image: 5,
    video: 16,
    audio: 16,
    document: 100,
  };

const agregarMensajeAlHistorial = (role, contenido) => {
  if (!selectedThread) return;
  const nuevoMensaje = {
    localId: crypto.randomUUID(),       // 👈 id estable del cliente
    role,
    content: contenido,
    createdAt: new Date().toISOString(),
    messageType: 'text',
  };
  setSelectedThread(prev => ({
    ...prev,
    messageHistory: [...prev.messageHistory, nuevoMensaje],
  }));
};


  const handleSendMessage = async () => {
    if (remainingConversations <= 0) {
      setIsLimitReached(true);
      setShowConversationLimitModal(true);
      return;
    }

    // Si hay una plantilla elegida, la envía en lugar del mensaje normal
    if (chosenTemplate) {
      await handleSendTemplate(chosenTemplate);
      setChosenTemplate(null);
      return;
    }

    const messageToSend = newMessage.trim();
    setNewMessage('');
    setIsSending(true);

    try {
      if (!selectedThread) return;

      if (!messageToSend && selectedFiles.length === 0) {
        setIsSending(false);
        return;
      }

      if (selectedThread.phoneNumber) {
        // WhatsApp
        if (selectedFiles.length > 0) {
          // Envío de media
       
       // ─── antes de armar el FormData ───
for (const file of selectedFiles) {
  const type   = getMessageType(file.type);         // image | video | audio | document
  const sizeMB = file.size / (1024 * 1024);         // bytes → MB

  if (sizeMB > MAX_FILE_SIZE[type]) {
    // 1. Toast visible
    const msg =
      type === 'image'  ? ' Tu imagen supera el límite de 5 MB.'   :
      (type === 'video' || type === 'audio')
                        ? ' Tu video/audio supera el límite de 16 MB.'
                        : ' Tu documento supera el límite de 100 MB.';
    toast.error(msg);

    setIsSending(false);
    return;                                         // cancela el envío
  }
}

          const formData = new FormData();
          formData.append('assistantId', selectedThread.assistantId);
          formData.append('phoneNumber', selectedThread.phoneNumber);
          if (messageToSend) {
            formData.append('caption', messageToSend);
          }
          selectedFiles.forEach((f) => formData.append('files', f));
          const resp = await fetch('https://backend.thethingapp.com/send-media', {
            method: 'POST',
            body: formData,
          });
          const data = await resp.json();
          if (!data.success) {
            console.error('Error al enviar media:', data.error);
            agregarMensajeAlHistorial('system', 'Error al enviar archivo.');
          } else {
            // Se agrega el mensaje al historial con rol assistant
            agregarMensajeAlHistorial('assistant', messageToSend);
            markThreadAsRead(selectedThread);
          }
          setSelectedFiles([]);
          setPreviewURLs([]);
          setNewMessage('');
           // 🔥 Y aquí también reseteas el input
  if (fileInputRef.current) {
    fileInputRef.current.value = null
  }
        } else {
          // Mensaje de texto para WhatsApp
          const resp = await fetch('https://backend.thethingapp.com/send-message', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              phoneNumber: selectedThread.phoneNumber,
              message: messageToSend,
              assistantId: selectedThread.assistantId,
            }),
          });
          const data = await resp.json();
          if (!data.success) {
            console.error('Error al enviar mensaje:', data.error);
            agregarMensajeAlHistorial('system', 'Error al enviar mensaje.');
          } else {
            // Se agrega el mensaje al historial con rol assistant
            agregarMensajeAlHistorial('assistant', messageToSend);
            markThreadAsRead(selectedThread);
          }
        }
      } else {
        // Chat Web
        const resp = await fetch(
          'https://backend.thethingapp.com/api/save-web-chat-thread',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              passKey: assistantPassKey,
              assistantId: selectedThread.assistantId,
              threadId: selectedThread.threadId,
              messages: [{ role: 'assistant', content: messageToSend }],
            }),
          }
        );
        const data = await resp.json();
        if (!data.success) {
          console.error('Error al guardar mensaje manual:', data.error);
          agregarMensajeAlHistorial('system', 'Error al guardar el mensaje.');
        } else {
          agregarMensajeAlHistorial('assistant', messageToSend);
          // => lastNormalMsgAt
          await updateDoc(
            doc(db, `threads_${selectedThread.assistantId}`, selectedThread.threadId),
            {
              lastNormalMsgAt: new Date().toISOString(),
            }
          );
          markThreadAsRead(selectedThread);
        }
      }
    } catch (error) {
      console.error('Error al enviar mensaje:', error);
      agregarMensajeAlHistorial('system', 'Hubo un error.');
    } finally {
      setIsSending(false);
    }
  };

  // Toggle switch auto response
  const finalAutoResponseEnabled = globalAutoResponseEnabled && isAutoResponseEnabled;

  const toggleAutoResponse = async () => {
    // Si la IA Global está OFF, mostramos un aviso o evitamos el toggle
    if (!globalAutoResponseEnabled) {
      toast.info('ℹ️ La respuesta automática GLOBAL está desactivada.');
      return;
    }

    if (remainingConversations <= 0) {
     toast.info('ℹ️ No te quedan conversaciones.');
      return;
    }
    const newVal = !(selectedThread?.autoResponseEnabled); 
    if (!selectedThread) return; // para evitar error si no hay thread
    
    try {
      // Llamas a tu backend o a Firestore
      const resp = await fetch('https://backend.thethingapp.com/update-thread-status', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          threadId: selectedThread.threadId,
          autoResponseEnabled: newVal,
          assistantId: selectedThread.assistantId,
        }),
      });
      const data = await resp.json();
      if (!data.success) {
        console.error('Error al actualizar autoResponse:', data.error);
      } else {
        // IMPORTANTE: Actualizar el selectedThread para que la interfaz muestre el cambio
        setSelectedThread((prevThread) =>
          prevThread ? { ...prevThread, autoResponseEnabled: newVal } : prevThread
        );
      }
    } catch (error) {
      console.error('Error al conectar con backend:', error);    
    }
  };

// helpers.js (o junto al otro helper)
const isLightColor = (hex) => {
  if (!hex) return false;
  const clean = hex.replace('#', '');
  const r = parseInt(clean.substr(0, 2), 16);
  const g = parseInt(clean.substr(2, 2), 16);
  const b = parseInt(clean.substr(4, 2), 16);
  return r * 0.299 + g * 0.587 + b * 0.114 > 186; // true  ⇒ fondo claro
};

// 🔸 NUEVO: devuelve la sombra adecuada para el texto resultante
const getTextShadow = (isLightText) =>
  isLightText
    ? '0 0 2px rgba(0,0,0,.35), 0 0 4px rgba(0,0,0,.45)'      // texto blanco → sombra oscura
    : '0 0 2px rgba(255,255,255,.35), 0 0 4px rgba(255,255,255,.45)'; // texto negro → sombra clara


  // Auxiliares
  const formatDate = (dateString) => {
    const options = {
      hour: '2-digit',
      minute: '2-digit',
      day: '2-digit',
      month: '2-digit',
    };
    return new Date(dateString).toLocaleString('es-ES', options).replace(',', '');
  };

  const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return '';
    // Ajusta según tu país
    const countryCode = phoneNumber.slice(0, 2);
    const areaCode = phoneNumber.slice(2, 3);
    const cityCode = phoneNumber.slice(3, 5);
    const firstPart = phoneNumber.slice(5, 9);
    const secondPart = phoneNumber.slice(9);
    return `+${countryCode} ${areaCode} ${cityCode} ${firstPart} ${secondPart}`;
  };

  const getPastelColor = (text) => {
    let hash = 0;
    for (let i = 0; i < text.length; i++) {
      hash = text.charCodeAt(i) + ((hash << 5) - hash);
      hash &= hash;
    }
    const hue = Math.abs(hash) % 360;
    const saturation = 40 + (Math.abs(hash) % 21);
    const lightness = 80 + (Math.abs(hash) % 6);
    const c = (1 - Math.abs((2 * lightness) / 100 - 1)) * (saturation / 100);
    const x = c * (1 - Math.abs(((hue / 60) % 2) - 1));
    const m = lightness / 100 - c / 2;
    let r, g, b;
    if (hue >= 0 && hue < 60) {
      r = c;
      g = x;
      b = 0;
    } else if (hue >= 60 && hue < 120) {
      r = x;
      g = c;
      b = 0;
    } else if (hue >= 120 && hue < 180) {
      r = 0;
      g = c;
      b = x;
    } else if (hue >= 180 && hue < 240) {
      r = 0;
      g = x;
      b = c;
    } else if (hue >= 240 && hue < 300) {
      r = x;
      g = 0;
      b = c;
    } else {
      r = c;
      g = 0;
      b = x;
    }
    const R = Math.round((r + m) * 255);
    const G = Math.round((g + m) * 255);
    const B = Math.round((b + m) * 255);
    return `rgba(${R}, ${G}, ${B}, 0.7)`;
  };

  const getInitials = (name) => {
    const parts = name.trim().split(' ');
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  };


// utils/formatMessageContent.js  (o donde lo tengas)
const formatMessageContent = (content, highlight = null) => {
  if (!content) return '';

  let formatted = content;

  /* ---------- resaltado ---------- */
  if (highlight) {
    const regex = new RegExp(`(${highlight})`, 'gi');
    formatted = formatted.replace(
      regex,
      '<span class="highlight">$1</span>'
    );
  }

  /* ---------- LISTAS BULLET ---------- *
   * - item   * item   • item   ▪ item   ◾ item                       */
  formatted = formatted.replace(
    /^\s*(?:[-*•▪◾]|\u2022)\s+(.+)$/gm,
    '<li data-ul>$1</li>'
  );

  /* ---------- LISTAS NUMERADAS ---------- *
   * 1. item   1) item   1- item                                               */
  formatted = formatted.replace(
    /^\s*\d+[.)-]\s+(.+)$/gm,
    '<li data-ol>$1</li>'
  );

  /* —— envolver bloques consecutivos de <li>…</li> —— */
  formatted = formatted
    /* unordered  <ul> */
    .replace(/((?:\s*<li data-ul>[\s\S]+?<\/li>)+)/g,
             m => '<ul>' + m.replace(/ data-ul/g,'') + '</ul>')
    /* ordered    <ol> */
    .replace(/((?:\s*<li data-ol>[\s\S]+?<\/li>)+)/g,
             m => '<ol>' + m.replace(/ data-ol/g,'') + '</ol>');

  /* ---------- NEGRITA ---------- *
   * *texto*  ó  **texto**                                              */
  formatted = formatted.replace(
    /(\*\*|\*)([^*]+?)\1/g,               // primero la negrita
    '<strong>$2</strong>'
  );

  /* ---------- CURSIVA ---------- *
   * _texto_  ó  __texto__                                              */
  formatted = formatted.replace(
    /(__|_)([^_]+?)\1/g,
    '<em>$2</em>'
  );

  /* ---------- ENLACES ---------- */
  const urlRegex = /(https?:\/\/[^\s)]+)([.,;:)\?!]+)?/g;
  formatted = formatted.replace(urlRegex, (match, p1, p2) =>
    `<a href="${p1}" target="_blank" rel="noopener noreferrer">${p1}</a>${p2 || ''}`
  );

  /* ---------- saltos de línea ---------- */
  formatted = formatted.replace(/\n/g, '<br>');

  return formatted;
};


  const handleAddNote = async () => {
    if (!selectedThread) return;
    const noteContent = window.prompt("Escribe tu nota interna:");
    if (!noteContent || noteContent.trim() === "") return;
  
    // Creamos el objeto de nota
    const newNoteMessage = {
      id: 'note_' + Date.now(), // identificador único
      role: 'nota',            // rol personalizado para identificar la nota
      content: noteContent,
      createdAt: new Date().toISOString(),
      messageType: 'alert'     // tipo personalizado para alertas/notas
    };
  
    try {
      // Actualizamos Firestore: se usa arrayUnion para agregar el mensaje sin reemplazar el historial
      const threadRef = doc(db, `threads_${selectedThread.assistantId}`, selectedThread.threadId);
      await updateDoc(threadRef, { messageHistory: arrayUnion(newNoteMessage) });
  
      // Actualizamos el estado local para que se refleje en la UI
      setSelectedThread(prev => ({
        ...prev,
        messageHistory: [...prev.messageHistory, newNoteMessage]
      }));
    } catch (err) {
      console.error("Error al agregar la nota:", err);
    }
  };
async function handleAddTagToThread(thread, tag) {
  if (!currentUser) return;
  if (!thread) return;

  // Evitar duplicados
  const yaTiene = (thread.etiquetas || []).some(
    (e) => (e.nombre ?? e.name) === tag.nombre
  );
  if (yaTiene) {
    toast.info('Esa etiqueta ya está en el chat', { autoClose: TAG_TOAST_DURATION });
    return;
  }

  const { assistantId, threadId } = thread;

  // 1) Feedback inmediato en UI: agregamos la etiqueta localmente
  const addTagLocally = (arr) => {
    if (!Array.isArray(arr)) return arr;
    return arr.map((t) =>
      t.threadId === threadId
        ? { ...t, etiquetas: [ ...(t.etiquetas || []), tag ] }
        : t
    );
  };

  setThreads((prev) => addTagLocally(prev));

  setAllThreads((prev) =>
    Array.isArray(prev) ? addTagLocally(prev) : prev
  );

  setGlobalSearchResults((prev) =>
    Array.isArray(prev) ? addTagLocally(prev) : prev
  );

  setSelectedThread((prev) =>
    prev && prev.threadId === threadId
      ? { ...prev, etiquetas: [ ...(prev.etiquetas || []), tag ] }
      : prev
  );

  // 2) Persistir en Firestore
  try {
    await updateDoc(
      doc(db, `threads_${assistantId}`, threadId),
      { etiquetas: arrayUnion(tag) }
    );

    // En rutas team, refrescás la lista completa como antes
    if (isTeamRoute) {
      await loadTeamThreadsRefetch();
    }

    toast.success('Etiqueta agregada ✔️', { autoClose: TAG_TOAST_DURATION });
  } catch (err) {
    console.error(err);
    toast.error('Error agregando etiqueta', { autoClose: TAG_TOAST_DURATION });
  }
}

// Selección múltiple
const [selectedIds, setSelectedIds] = useState(new Set());
const [lastSelectedIdx, setLastSelectedIdx] = useState(null);

const isSelected = (id) => selectedIds.has(id);

const clearSelection = () => setSelectedIds(new Set());

const selectAllVisible = () => {
  setSelectedIds(new Set(finalDisplayedThreads.map(t => t.threadId)));
};

const toggleSelectOne = (threadId, checked) => {
  setSelectedIds(prev => {
    const next = new Set(prev);
    if (checked === undefined) {
      next.has(threadId) ? next.delete(threadId) : next.add(threadId);
    } else {
      checked ? next.add(threadId) : next.delete(threadId);
    }
    return next;
  });
};



// Shift-click para seleccionar rangos
const toggleSelectWithIndex = (e, index, threadId) => {
  e.stopPropagation();
  setSelectedIds(prev => {
    const next = new Set(prev);
    if (e.shiftKey && lastSelectedIdx !== null && finalDisplayedThreads.length) {
      const [a, b] = [lastSelectedIdx, index].sort((x, y) => x - y);
      for (let i = a; i <= b; i++) next.add(finalDisplayedThreads[i].threadId);
    } else {
      next.has(threadId) ? next.delete(threadId) : next.add(threadId);
      setLastSelectedIdx(index);
    }
    return next;
  });
};

// Utilidad para encontrar el thread por id en cualquier arreglo activo
const findThreadById = (id) =>
  (finalDisplayedThreads.find(t => t.threadId === id)) ||
  (threads.find(t => t.threadId === id)) ||
  ((allThreads || []).find(t => t.threadId === id)) || null;

const bulkMarkUnread = async () => {
  for (const id of selectedIds) {
    const t = findThreadById(id);
    if (t) await markThreadAsUnread(t);
  }
  // ❌ NO clearSelection();
};
const bulkRemoveTag = async (tag) => {
  // Quita 'tag' de cada chat seleccionado que la tenga
  const removedFrom = [];
  for (const id of selectedIds) {
    const t = findThreadById(id);
    if (!t) continue;

    // buscamos el objeto 'tag' exacto dentro del hilo (por nombre)
    const toRemove = (t.etiquetas || []).find(
      (e) => (e.nombre ?? e.name) === tag.nombre
    );
    if (!toRemove) continue;

    // reusamos tu helper existente que ya actualiza Firestore y el estado local
    await handleRemoveTagFromThread(t, toRemove);
    removedFrom.push(id);
  }

  if (removedFrom.length) {
    toast.success(`Etiqueta “${tag.nombre}” quitada de ${removedFrom.length} chat(s).`);
  } else {
    toast.info(`Ninguno de los seleccionados tenía “${tag.nombre}”.`);
  }
};


const bulkMarkRead = async () => {
  for (const id of selectedIds) {
    const t = findThreadById(id);
    if (t) await markThreadAsRead(t);
  }
  // ❌ NO clearSelection();
};

const bulkMoveToColumn = async (columnId) => {
  for (const id of selectedIds) {
    const t = findThreadById(id);
    if (t) await handleMoveToColumn(t, columnId);
  }
  // ❌ NO clearSelection();
};

const bulkAddTag = async (tag) => {
  for (const id of selectedIds) {
    const t = findThreadById(id);
    if (t) await handleAddTagToThread(t, tag);
  }
  // ❌ NO clearSelection();
};

// ——— TAGS detectadas en los chats seleccionados (para la barrita bulk) ———
const selectedThreadsArr = useMemo(() => {
  const arr = [];
  selectedIds.forEach((id) => {
    const t = findThreadById(id);
    if (t) arr.push(t);
  });
  return arr;
}, [selectedIds, finalDisplayedThreads, threads, allThreads]);

const selectedTagsUnion = useMemo(() => {
  const map = new Map(); // nombre -> { nombre, color, count }
  selectedThreadsArr.forEach((t) => {
    (t.etiquetas || []).forEach((e) => {
      const nombre = typeof e === 'string' ? e : (e.nombre ?? e.name ?? '');
      const color  = typeof e === 'string' ? '#777' : (e.color ?? '#777');
      if (!nombre) return;
      const item = map.get(nombre);
      if (item) item.count += 1;
      else map.set(nombre, { nombre, color, count: 1 });
    });
  });
  // si quieres, ordénalas por nombre
  return Array.from(map.values()).sort((a, b) => a.nombre.localeCompare(b.nombre));
}, [selectedThreadsArr]);

// Cuenta cuántos de los seleccionados tienen cada etiqueta (por nombre)
const selectedTagCounts = useMemo(() => {
  const map = new Map();
  selectedThreadsArr.forEach((th) => {
    (th.etiquetas || []).forEach((e) => {
      const name = typeof e === 'string' ? e : (e.nombre ?? e.name ?? '');
      if (!name) return;
      map.set(name, (map.get(name) || 0) + 1);
    });
  });
  return map; // name -> count
}, [selectedThreadsArr]);


const removeFromSelection = (ids) => {
  setSelectedIds(prev => {
    const next = new Set(prev);
    ids.forEach(id => next.delete(id));
    return next;
  });
};


const bulkDelete = async () => {
  if (!selectedIds.size) return;
  const ok = window.confirm(`¿Eliminar ${selectedIds.size} chat(s)?`);
 if (!ok) return;

  const deleted = [];
 for (const id of selectedIds) {
   // 👇 sin confirmación por item ni toast por item
   await deleteThreadPermanently(id, { silent: true });
   deleted.push(id);
 }
 removeFromSelection(deleted);
   toast.success(`✔️ Se eliminaron ${deleted.length} chat(s).`);
};


// justo después de calcular isMobile / isInThreadDetail:
useEffect(() => {
  if (!isMobile) return;

  const inDetailPath = /^\/messages\/[^/]+\/[^/]+$/.test(location.pathname);
  const chatVisible = !!selectedThread && !showMobileThreadList; // en móvil, detalle visible = lista oculta

  if (inDetailPath && !chatVisible) {
    const basePath = isTeamRoute
      ? `/messages/team-${teamMemberUniqueId}`
      : assistantId ? `/messages/${assistantId}` : '/messages';

    navigate(basePath, { replace: true }); // evita dejar historial “sucio”
  }
}, [
  isMobile,
  showMobileThreadList,
  selectedThread,
  assistantId,
  isTeamRoute,
  teamMemberUniqueId,
  location.pathname,
  navigate
]);


useEffect(() => {
  if (listRef.current) {
    listRef.current.resetAfterIndex(finalDisplayedThreads.length, false);
  }
}, [loadingAllThreads, finalDisplayedThreads.length]);



/** Quita “tag” del hilo */
async function handleRemoveTagFromThread(thread, tag) {
  if (!currentUser) return;
  if (!thread) return;

  const { assistantId, threadId } = thread;

  try {
    const ref = doc(db, `threads_${assistantId}`, threadId);
    await updateDoc(ref, { etiquetas: arrayRemove(tag) });

    const removeTagLocally = (arr) => {
      if (!Array.isArray(arr)) return arr;
      return arr.map((t) =>
        t.threadId === threadId
          ? {
              ...t,
              etiquetas: (t.etiquetas || []).filter(
                (e) => (e.nombre ?? e.name) !== tag.nombre
              ),
            }
          : t
      );
    };

    setThreads((prev) => removeTagLocally(prev));
    setAllThreads((prev) => removeTagLocally(prev));
    setGlobalSearchResults((prev) => removeTagLocally(prev));

    if (selectedThread?.threadId === threadId) {
      setSelectedThread((prev) =>
        prev
          ? {
              ...prev,
              etiquetas: (prev.etiquetas || []).filter(
                (e) => (e.nombre ?? e.name) !== tag.nombre
              ),
            }
          : prev
      );
    }

    toast.success('Etiqueta eliminada ✔️', { autoClose: TAG_TOAST_DURATION });
  } catch (err) {
    console.error(err);
    toast.error('Error eliminando etiqueta', { autoClose: TAG_TOAST_DURATION });
  }
}


/** Elimina definitivamente una etiqueta del catálogo del usuario */
async function handleDeleteTag(tag) {
  if (!currentUser) return;
  try {
    // 1) la quitamos del array de etiquetas del usuario
await updateDoc(doc(db, "assistants", assistantId), {
      etiquetas: arrayRemove(tag)
    });

    // 2) feedback inmediato en UI
    setTags(prev => prev.filter(t => t.nombre !== tag.nombre));

    // 3) si el filtro estaba usando esa etiqueta, lo limpiamos
    setActiveTags(prev => prev.filter(n => n !== tag.nombre));

    toast.success("Etiqueta eliminada ✔️", { autoClose: TAG_TOAST_DURATION });
  } catch (err) {
    console.error(err);
    toast.error("Error eliminando la etiqueta", { autoClose: TAG_TOAST_DURATION });
  }
}

  const handleEditNote = async (noteMessage) => {
    // Solicita el nuevo contenido
    const newContent = window.prompt("Edita la nota:", noteMessage.content);
    if (!newContent || newContent.trim() === "" || newContent.trim() === noteMessage.content) return;
  
    // Crea la nota actualizada (puedes agregar una propiedad 'editedAt' si lo deseas)
    const updatedNote = {
      ...noteMessage,
      content: newContent,
      editedAt: new Date().toISOString(),
    };
  
    try {
      const threadRef = doc(db, `threads_${selectedThread.assistantId}`, selectedThread.threadId);
      // Remueve la nota antigua
      await updateDoc(threadRef, { messageHistory: arrayRemove(noteMessage) });
      // Agrega la nota actualizada
      await updateDoc(threadRef, { messageHistory: arrayUnion(updatedNote) });
      // Actualiza el estado local
      setSelectedThread(prev => ({
        ...prev,
        messageHistory: prev.messageHistory.map(m => (m.id === noteMessage.id ? updatedNote : m)),
      }));
    } catch (err) {
      console.error("Error al editar la nota:", err);
    }
  };

  
  
  const handleDeleteNote = async (noteMessage) => {
    const confirmDelete = window.confirm("¿Estás seguro de eliminar esta nota?");
    if (!confirmDelete) return;
    try {
      const threadRef = doc(db, `threads_${selectedThread.assistantId}`, selectedThread.threadId);
      await updateDoc(threadRef, { messageHistory: arrayRemove(noteMessage) });
      // Actualiza el estado local quitando la nota
      setSelectedThread(prev => ({
        ...prev,
        messageHistory: prev.messageHistory.filter(m => m.id !== noteMessage.id),
      }));
    } catch (err) {
      console.error("Error al eliminar la nota:", err);
    }
  };

  
  function renderThreadOptionsDropdown(thread) {
    if (thread.threadId !== isMoveMenuOpen) return null;

    return (
      <div className="order-dropdown-messages" >
{/* Estado de lectura: SIEMPRE mostrar ambas opciones */}
<div
  className={`option ${thread.readByUser ? 'disabled' : ''}`}
  onClick={(e) => {
    e.stopPropagation();
    if (!thread.readByUser) markThreadAsRead(thread);
  }}
  title={thread.readByUser ? 'Ya está marcado como leído' : 'Marcar como leído'}
>
  Marcar como leído
</div>

<div
  className={`option ${!thread.readByUser ? 'disabled' : ''}`}
  onClick={(e) => {
    e.stopPropagation();
    if (thread.readByUser) markThreadAsUnread(thread);
  }}
  title={!thread.readByUser ? 'Ya está marcado como no leído' : 'Marcar como no leído'}
>
  Marcar como no leído
</div>


        {/* Opción 2: Eliminar chat */}
        <div
          className="option"
          onClick={(e) => {
            e.stopPropagation();
            handleDeleteThread(thread.threadId);
          }}
        >
          {/* Ícono + texto */}
          <FontAwesomeIcon icon={faTrashAlt} className="trash-icon" />
          <span style={{ marginLeft: '6px' }}>Eliminar chat</span>
        </div>

         {/* —— NUEVO —— */}
     <div
       className="option has-submenu tags-option" 
 onClick={e=>{ e.stopPropagation();
   tagDropdownOpenThreadId===thread.threadId ? closeAll() : openTags(thread.threadId);
 }}
 onMouseEnter={()=> openTags(thread.threadId)}
 onMouseLeave={()=> closeAll()}
     >
       Agregar etiqueta
       {/* sub-lista con todas mis etiquetas */}
       {tagDropdownOpenThreadId===thread.threadId && (
  <div
     className="move-dropdown-content"
     style={{             /* idéntico al sub-menú CRM */
       display: 'block',
       maxHeight: 250,
       overflowY: 'auto',
       zIndex: 1000        /* asegura que quede por encima */
     }}
  >
         {tags.map(t => {
   const applied = (thread.etiquetas || []).some(e => e.nombre === t.nombre);
   return (
     <div
       key={t.nombre}
       className="move-option tag-row"
       onClick={e => {
         /* si NO está aplicada → la agregamos */
         if (!applied) {
           e.stopPropagation();
           handleAddTagToThread(thread, t);
           closeAll();
         }
       }}
     >
       <span className="tag-dot" style={{ background: t.color }} />
       <span>{t.nombre}</span>

       {/* si YA está aplicada mostramos la × roja para quitarla */}
       {applied && (
         <span
           className="remove-tag"
           onClick={e => {
             e.stopPropagation();
             handleRemoveTagFromThread(thread, t);
             closeAll();
           }}
         >
           ×
         </span>
       )}
     </div>
   );
})}

         </div>
       )}
     </div>


        {/* Opción 3: Enviar al CRM */}
        <div
          className="option has-submenu"
        onMouseEnter={()=> openCrm(thread.threadId)}
 onMouseLeave={()=> closeAll()}
 onClick={e=>{ e.stopPropagation();
   crmDropdownOpenThreadId===thread.threadId ? closeAll() : openCrm(thread.threadId);
 }}
        >
          <span>Enviar al CRM</span>
          <div
            className="move-dropdown-content"
            style={{
              display:
                crmDropdownOpenThreadId === thread.threadId ||
                hoveredCrmThreadId === thread.threadId
                  ? 'block'
                  : 'none',
            }}
          >
            {crmColumns.map((column) => (
              <div
                key={column.id}
                className="move-option"
                onClick={(e) => {
                  e.stopPropagation();
                  handleMoveToColumn(thread, column.id);
                }}
              >
                {column.name}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // Efecto para marcar el thread como no leído solo cuando llegan mensajes del cliente
  useEffect(() => {
    threads.forEach((thread) => {
      const prevThread = prevThreadsRef.current.find(
        (t) => t.threadId === thread.threadId
      );
      if (!prevThread) return;

      const prevLength = prevThread.messageHistory?.length || 0;
      const currentLength = thread.messageHistory?.length || 0;

      if (currentLength <= prevLength) return;

      const newMessages = thread.messageHistory.slice(prevLength);
      const hasClientMessage = newMessages.some((msg) => msg?.role === 'user');

      if (hasClientMessage) {
        if (selectedThread?.threadId === thread.threadId) {
          markThreadAsRead(thread);
          return;
        }
        markThreadAsUnread(thread);
      }
    });
    prevThreadsRef.current = threads;
  }, [threads, selectedThread?.threadId]);

  useEffect(() => {
    if (!selectedThread || selectedThread.threadId !== threadId) return;

    if (!messageHistoryRef.current) return;

    const currentCount = selectedThread.messageHistory.length;

    if (currentCount > prevMessageCountRef.current) {
      messageHistoryRef.current.scrollTo({
        top: messageHistoryRef.current.scrollHeight,
        behavior: 'smooth',
      });
    }
    prevMessageCountRef.current = currentCount;
  }, [selectedThread?.messageHistory, threadId]);

  /* ── auto-scroll al abrir un chat ── */
  useEffect(() => {
    if (!selectedThread || !messageHistoryRef.current) return;
    const timer = setTimeout(() => {
      messageHistoryRef.current.scrollTo({
        top: messageHistoryRef.current.scrollHeight,
        behavior: 'smooth',
      });
    }, 80);
    return () => clearTimeout(timer);
  }, [selectedThread?.threadId]);

  useEffect(() => {
  const noFilter =
    !showOnlyUnread &&
    !filter &&
    !filterStartDate &&
    !filterEndDate &&
    activeTags.length === 0;

  if (noFilter && !isGlobalSearchOpen) {
    setGlobalSearchResults([]);
  }
}, [
  showOnlyUnread,
  filter,
  filterStartDate,
  filterEndDate,
  activeTags,
  isGlobalSearchOpen,
]);

// ─────────────────────────────────────────────────────────────
//  Botón “Descargar conversación” (solo para hordonez@…)
// ─────────────────────────────────────────────────────────────
const isHordonez = (currentUser?.email || '').toLowerCase() === 'hordonez@mktmarketingdigital.com';

const safeFilename = (name) =>
  String(name || '')
    .replace(/[<>:"/\\|?*\x00-\x1F]/g, '_') // inválidos en FS
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 100);

const downloadJSON = (obj, filename) => {
  const blob = new Blob([JSON.stringify(obj, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

const handleDownloadConversation = () => {
  // usar el seleccionado; si no, intentar tomarlo por params
  const thread =
    selectedThread ||
    (threadId ? findThreadById(threadId) : null);

  if (!thread) {
    toast.info('ℹ️ No hay una conversación seleccionada.');
    return;
  }

  const payload = {
    assistantId: thread.assistantId,
    threadId: thread.threadId,
    senderName: thread.senderName || 'Chat Web',
    phoneNumber: thread.phoneNumber || null,
    createdAt: thread.createdAt || null,
    lastMessageAt: thread.messageHistory?.at(-1)?.createdAt || null,
    messageCount: thread.messageHistory?.length || 0,
    // history “limpio” (solo campos útiles)
    messageHistory: (thread.messageHistory || []).map(m => ({
      role: m.role,
      content: m.content,
      createdAt: m.createdAt,
      id: m.id || null,
      messageType: m.messageType || 'text',
    })),
  };

  const ts = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-');
  const base = safeFilename(`${payload.senderName}-${payload.threadId}-${ts}`);
  downloadJSON(payload, `${base}.json`);
  toast.success('✔️ Descargando conversación…');
};


  // 1) Definimos una constante que indica si es un hilo de WhatsApp (tiene phoneNumber)
  const isWhatsAppThread = !!selectedThread?.phoneNumber;

  // 2) Combinamos esa condición con las de "freeze" para aplicar bloqueos

  const canClickSendButton = !freezeFaFile && !isLimitReached;
  const shouldBlurInput = freezeFaFile;
  const isInputDisabled = isChatFrozen;

const ThreadRow = React.memo(function ThreadRow({ index, style, data }) {
  const {
    threads, handleThreadClick, toggleFavorite,
    renderThreadOptionsDropdown, isMoveMenuOpen,
    getPastelColor, getInitials, formatDate, isTeamRoute,
    showSoftLoaderRow, activeThreadId,
  } = data;

  // 👇 si es la fila extra (loader), renderizamos el soft-loading como último item
  if (showSoftLoaderRow && index === threads.length) {
    return (
      <li style={style} className="thread-item">
        <div className="soft-loading" style={{ width:'100%', display:'flex', justifyContent:'center', alignItems:'center', padding:'0.5rem 0' }}>
          <div className="spinner" aria-label="Filtrando más chats…" />
          <span style={{ marginLeft: 8 }}>Filtrando más chats…</span>
        </div>
      </li>
    );
  }

  const thread = threads[index];
  if (!thread) return null;

const tags = thread.etiquetas || [];
const withTags = (thread.etiquetas || []).length > 0;
const isActive = activeThreadId && thread.threadId === activeThreadId;




return (
    <li
      style={style}
  className={`thread-item ${withTags ? 'wrap' : ''} ${isActive ? 'active' : ''} ${data.isSelected(thread.threadId) ? 'selected' : ''}`}
      onClick={() => handleThreadClick(thread)}
    >
  <div className='thread-item-no-tag'>

<div className="favorite-star" onClick={(e) => e.stopPropagation()}>
  <label className="select-square" title={isSelected(thread.threadId) ? 'Quitar de la selección' : 'Seleccionar'}>
    <input
      type="checkbox"
      checked={data.isSelected(thread.threadId)}
      onChange={(ev) => data.toggleSelectWithIndex(ev, index, thread.threadId)}
      onClick={(ev) => ev.stopPropagation()}
    />
    <span className="box" />
  </label>
</div>

                        <div className="thread-info" style={{ display: 'flex', alignItems: 'start' }}>
                          {thread.phoneNumber ? (
                            <div
                              className="avatar-container"
                              style={{ backgroundColor: getPastelColor(thread.senderName || 'Chat Web') }}
                            >
                              <span className="avatar-initials">
                                {getInitials(thread.senderName || 'Chat Web')}
                              </span>
                              <FaWhatsapp className="whatsapp-icon" />
                            </div>
                          ) : (
                            <div className="web-chat-avatar-container">
                              <img
                                src={webChatIcon}
                                alt="Web Chat Icon"
                                className="web-chat-icon"
                              />
                            </div>
                          )}
                          
                          <div className="thread-details-preview" style={{ flex: 1, marginLeft: '10px' }}>
                            <p className="thread-sender-name" style={{ margin: '0' }}>
                              {thread.senderName || 'Chat Web'}
                            </p>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <p
                                className="thread-last-message thread-preview-text"
                                style={{
                                  margin: 0,
                                  overflow: 'hidden',
                                  whiteSpace: 'nowrap',
                                  textOverflow: 'ellipsis',
                                  maxWidth: '18em',
                                  color: '#AC9ED4',
                                }}
                              >
                                {thread.messageHistory[thread.messageHistory.length - 1]?.content ||
                                  ''}
                              </p>
                            </div>
                          </div>
                          <div className="thread-date-wrapper">
                            <span className="thread-date-info">
                              {formatDate(
                                thread.messageHistory[thread.messageHistory.length - 1]?.createdAt
                              )}
                            </span>
                            {!thread.readByUser && thread.threadId !== selectedThread?.threadId && (
                              <span className="unread-dot below-date"></span>
                            )}
                          </div>
                          <div
                            className="options-thread"
                            onClick={(e) => {
                              e.stopPropagation();
                              setIsMoveMenuOpen(
                                isMoveMenuOpen === thread.threadId ? null : thread.threadId
                              );
                            }}
                          >
                            <FontAwesomeIcon icon={faEllipsisV} className="options-icon" />
                            {renderThreadOptionsDropdown(thread)}
                          </div>
                        </div>
</div>
  <div className='thread-item-tag'>
      {/* ⭐ NUEVO: fila de chips —solo si hay etiquetas— */}
      {withTags && (
      <div className="thread-tags">
{thread.etiquetas.map(t => {
  const lightBg   = isLightColor(t.color);
  const lightText = !lightBg;      // fondo claro → texto oscuro

  return (
    <span
      key={t.nombre}
      className="thread-tag-chip"
      style={{
        background : t.color,
        color      : lightText ? '#FFF' : '#000',
      }}
    >
      {t.nombre}
    </span>
  );
})}

      </div>
    )}
              </div>
                      </li>
  );
});

  

  return (
    <div
      className={`threads-viewer ${shouldUseFixed ? "fixed-mobile" : "normal-mobile"}`}
    >
      {(loadingAgents || (loadingThreads && showLoading)) ? (
        <div
          className="loading"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: 'calc(100vh - 100px)',
            fontSize: 'xx-large'
          }}
        >
          Cargando...
        </div>
      ) : noAgents ? (
        <div
          className="no-agent-message"
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: 'large',
            textAlign: 'center',
            padding: '1em'
          }}
        >
          Para ver los mensajes debe crear un agente...
        </div>
      ) : (
        <>
          {/* LISTA DE THREADS */}
          <div className="threads-list" style={{
            display: windowWidth <= 1000 ? (showMobileThreadList ? 'flex' : 'none') : 'flex',
          }}>
            {/* Encabezado de la lista de hilos */}
            <div className="threads-list-header">
              {/* SECTION IZQUIERDA */}
              <div className="header-left"
              style={{
                  display: windowWidth <= 1000 && isGlobalSearchOpen ? 'none' : 'flex'
                }}
              >


{/* === Icono exportar contactos === */}
{selectedAgent && (
  <div
    className="download-icon-wrapper"
    onClick={downloadContactsXlsx}
    title="Exportar contactos (XLSX)"
    style={{ opacity: isDownloadingContacts ? 0.5 : 1, pointerEvents: isDownloadingContacts ? 'none' : 'auto' }}
  >
    <FontAwesomeIcon icon={faDownload} className="download-icon" />
  </div>
)}


                                {/* === Botón de etiquetas === */}
<div
  className="tag-icon-wrapper"
  onClick={() => setIsTagMenuOpen((v) => !v)}
  title="Gestionar etiquetas"
>
  <FontAwesomeIcon icon={faTags} className="tag-icon" />
</div>

              
                <div ref={orderContainerRef} className="order-filter-wrap">
                  {/* Dropdown para "Ordenar" */}
                  <div className="order-dropdown-wrapper">
                    <div
                      className="order-filter-messages"
                      onClick={(e) => {
                        e.stopPropagation(); // Evita que el click se propague
                        setIsOrderDropdownOpen(!isOrderDropdownOpen);
                        setIsFilterDropdownOpen(false);
                      }}
                    >

                    {isOrderDropdownOpen && (
                      <div className="order-dropdown-messages">
                        <div
                          onClick={() => {
                            setOrderBy('name');
                            setIsOrderDropdownOpen(false);
                          }}
                        >
                          Nombre
                        </div>
                        <div
                          onClick={() => {
                            setOrderBy('date');
                            setIsOrderDropdownOpen(false);
                          }}
                        >
                          Fecha de creación
                        </div>
                        <div
                          onClick={() => {
                            setOrderBy('lastMessage');
                            setIsOrderDropdownOpen(false);
                          }}
                        >
                          Fecha de último mensaje
                        </div>
                      </div>
                    )}
                  </div>
  
                  {/* Dropdown para "Filtrar" */}
  {/* 👇 NUEVO contenedor ─ incluye icono y menú ─ */}
  <div className="filter-container" ref={filterContainerRef}>
    
    {/* icono/caret que abre el menú */}
    <div
      className="filter-dropdown-wrapper"
      onClick={() => {
        setIsFilterDropdownOpen((v) => !v);
        setIsOrderDropdownOpen(false);
      }}
    >
                      <span className="order-filter-text">Filtrar por</span>
                      <FontAwesomeIcon icon={faCaretDown} className="caret-icon" />
                    </div>
                    </div>
                    {isFilterDropdownOpen && (
                      <div className="order-dropdown-messages-filtro">

{/* --- PENDIENTES --- */}
<div
  className="filter-unread"
  style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
  onClick={() => setShowOnlyUnread(v => !v)}
>
  <span>Pendientes</span>

  {/* Muestra la × sólo cuando el filtro está activo */}
  {showOnlyUnread && (
    <span
      className="remove-filter"
      style={{ marginLeft: '0.5em', opacity: 0.5 }}
      onClick={(e) => {
        e.stopPropagation();
        setShowOnlyUnread(false);
        setIsFilterDropdownOpen(false);
      }}
    >
      ×
    </span>
  )}
</div>          
                        <div
                          onClick={() => {
                            // Filtro de favoritos
                            if (filter === 'favorites') {
                              setFilter(null);
                            } else {
                              setFilter('favorites');
                            }
                            setIsFilterDropdownOpen(false);
                          }}
                          style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                        >
                          <span>Destacado</span>
                          {filter === 'favorites' && (
<span
      className="remove-filter"
      style={{ marginLeft: '0.5em', opacity: 0.5 }}
      onClick={(e) => {
        e.stopPropagation();
        setFilter(null);
        setIsFilterDropdownOpen(false);
      }}
   >
     ×
   </span>
                          )}
                        </div>
        <span className="filter-date">Fecha:</span>
                        <div className="filter-by-date">
                          <label>Desde</label>
                          <div className="date-wrapper">
                            <input
                              type="date"
                              value={filterStartDate || ''}
                              onChange={(e) => setFilterStartDate(e.target.value)}
                              className="date-input"
                            />
                            {!filterStartDate && (
                              <span className="fake-placeholder">dd/mm/aaaa</span>
                            )}
                          </div>
  
                          <label>Hasta</label>
                          <div className="date-wrapper">
                            <input
                              type="date"
                              value={filterEndDate || ''}
                              onChange={(e) => setFilterEndDate(e.target.value)}
                              className="date-input"
                            />
                            {!filterEndDate && (
                              <span className="fake-placeholder">dd/mm/aaaa</span>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

              </div>

              
              {isTagMenuOpen && (
<div
  className="tag-menu-dropdown"
  onMouseLeave={() => setIsTagMenuOpen(false)}
>
{tags.map(t => {
  const isActive = activeTags.includes(t.nombre);

  return (
    <div              /* <── aquí mismo */
      key={t.nombre}
      className="tag-row"
      onClick={() => {
        /* clic en cualquier parte de la fila = activar / desactivar filtro */
        setActiveTags(prev =>
          prev.includes(t.nombre)
            ? prev.filter(n => n !== t.nombre)
            : [...prev, t.nombre]
        );
        setIsTagMenuOpen(false);
      }}
    >
      <span className="tag-dot" style={{ background: t.color }} />
      <span>{t.nombre}</span>

      {/* ✔️ NUEVO: botón “×” para borrar - no propaga el click */}
{/* ✔️ Botón para borrar - mantiene los mismos estilos (delete-tag) */}
<span
  className="delete-tag"
  onClick={e => {
    e.stopPropagation(); // evita activar / desactivar filtro
    const ok = window.confirm(`¿Eliminar la etiqueta “${t.nombre}”?`);
    if (ok) handleDeleteTag(t);
  }}
  title={`Eliminar “${t.nombre}”`}
  aria-label={`Eliminar etiqueta ${t.nombre}`}
>
  <FontAwesomeIcon icon={faTrashAlt} />
</span>

      {/* check de “filtro activo” */}
      {isActive && <span className="check-mark">✓</span>}
    </div>
  );
})}


    {/* botón “+” para crear nueva */}
    <div
      className="tag-row add-tag"
      onClick={() => {
        setShowTagCreator(true);
        setIsTagMenuOpen(false);
      }}
    >
      <FontAwesomeIcon icon={faPlus} />
      <span>Nueva etiqueta</span>
    </div>
  </div>
)}

{showTagCreator && (
  <div className="tag-backdrop" onClick={() => setShowTagCreator(false)}>
    <div className="tag-modal" onClick={e => e.stopPropagation()}>

      <h3>Nueva etiqueta</h3>

      <input
        className="tag-input"
        value={newTagName}
        maxLength={20}
        placeholder="Nombre…"
        onChange={e => setNewTagName(e.target.value)}
      />

 {/* ⬇️  Paleta fija */}
 <div className="predefined-colors">
   {PREDEFINED_COLORS.map(c => (
     <button
       key={c}
       className="color-swatch"
       style={{
         background: c,
         border: newTagColor === c ? "2px solid #fff" : "none"
       }}
       onClick={() => setNewTagColor(c)}
     />
   ))}
    {/* ⬇️  Selector libre: queda al final */}
 <label className="color-picker">
   <input
     type="color"
     value={newTagColor}
     onChange={e => setNewTagColor(e.target.value)}
   />
 </label>


 </div>


     <button
      className="tag-save"
       disabled={!newTagName.trim() || !assistantId }
       onClick={async () => {
         const nueva = { nombre: newTagName.trim(), color: newTagColor };
         try {
           await setDoc(
             doc(db, "assistants", assistantId),
             { etiquetas: arrayUnion(nueva) },
             { merge: true }
         );
          toast.success("Etiqueta creada ✔️", { autoClose: TAG_TOAST_DURATION });
           setNewTagName("");
           setNewTagColor("#673AB7");
           setShowTagCreator(false);
         } catch {
           toast.error("Error guardando etiqueta", { autoClose: TAG_TOAST_DURATION });
         }
       }}
     >
        Guardar
      </button>
    </div>
  </div>
)}

  {showTagEditor && (
  <div className="tag-backdrop" onClick={()=>setShowTagEditor(false)}>
    <div className="tag-modal" onClick={e=>e.stopPropagation()}>
      <h3>Editar etiqueta</h3>

      <input
        className="tag-input"
        value={editName}
        onChange={e=>setEditName(e.target.value)}
      />

      <label className="color-picker">
        <input
          type="color"
          value={editColor}
          onChange={e=>setEditColor(e.target.value)}
        />
      </label>

      <div style={{display:"flex",gap:"1em",flexWrap:"wrap",justifyContent:"center"}}>
        <button
          className="tag-save"
          disabled={!editName.trim()}
          onClick={async ()=>{
            try{
// EDITAR en assistants/{assistantId}
await updateDoc(doc(db,"assistants",assistantId),{
  etiquetas: arrayRemove(editingTag)
});
const nueva = { nombre:editName.trim(), color:editColor };
await updateDoc(doc(db,"assistants",assistantId),{
  etiquetas: arrayUnion(nueva)
  });
              toast.success("Etiqueta actualizada ✔️", { autoClose: TAG_TOAST_DURATION });
              setShowTagEditor(false);
            }catch{ toast.error("Error actualizando", { autoClose: TAG_TOAST_DURATION }); }
          }}
        >
          Guardar
        </button>

        <button
          className="tag-save"
          style={{background:"#993333"}}
          onClick={async ()=>{
            const ok = window.confirm(`¿Eliminar "${editingTag.nombre}"?`);
            if(!ok) return;
            try{
              await updateDoc(doc(db,"assistants",assistantId),{
                etiquetas: arrayRemove(editingTag)
              });
              toast.success("Etiqueta eliminada ✔️", { autoClose: TAG_TOAST_DURATION });
              setShowTagEditor(false);
            }catch{ toast.error("Error eliminando", { autoClose: TAG_TOAST_DURATION }); }
          }}
        >
          Eliminar
        </button>
      </div>
    </div>
  </div>
)}

              {/* SECTION DERECHA: Filtros (Ordenar + Ícono Filtro) siempre visibles */}
              <div 
                className="header-right-threads"
                
              >
{isHordonez && selectedAgent && (
  <button
    className="download-all-button"
    onClick={downloadAllConversations}
    title="Descargar todas las conversaciones (JSON)"
    style={{
      background: 'linear-gradient(120deg, #3f297dc0 0%,  #1a1742 60%)',
      color: '#fff',
      border: 'none',
      borderRadius: '8px',
      padding: '10px 18px',
      fontSize: '14px',
      fontWeight: '600',
      cursor: 'pointer',
      boxShadow: '0 2px 8px rgba(107, 70, 193, 0.3)',
      transition: 'all 0.2s ease',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      margin: '10px',
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'translateY(-2px)';
      e.currentTarget.style.boxShadow = '0 4px 12px rgba(107, 70, 193, 0.4)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.boxShadow = '0 2px 8px rgba(107, 70, 193, 0.3)';
    }}
  >
    <FontAwesomeIcon icon={faDownload} /> Exportar chats
  </button>
)}
{/* 👇 Rango 1–N de [total], solo si NO es team y NO hay búsqueda global abierta */}
{!isTeamRoute && !isGlobalSearchOpen && (
  <span className="threads-count" title="Rango mostrado en esta vista">
    {rangeLabel}
  </span>
)}


                  {isGlobalSearchOpen ? (
                  /* Si la búsqueda global está abierta => mostramos el input y botones */
                  <div className="global-search-container">
                    <input
                      type="text"
                      className="global-search-input"
                      placeholder="Buscar en todos los chats..."
                      value={globalSearchTerm}
                      onChange={(e) => setGlobalSearchTerm(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') handleGlobalSearch();
                      }}
                      aria-label="Buscar en todos los chats"
                    />
                    <button onClick={handleGlobalSearch} className="global-search-button">
                      Buscar
                    </button>
                    <button
  className="global-search-close-button"
  onClick={handleCloseGlobalSearch}
  aria-label="Cerrar búsqueda global"
>
  ×
</button>
                </div>
                ) : (
                  /* Si NO está abierta la búsqueda => icono + toggle de Pendientes */
                  <>
                    <div
                      className="global-search-icon-wrapper"
                      onClick={() => setIsGlobalSearchOpen(!isGlobalSearchOpen)}
                      title="Buscar en todos los chats"
                    >
                      <FontAwesomeIcon icon={faSearch} className="search-icon" />
                    </div>

                  </>
                )}
              </div>
            </div>
            {/* Master checkbox + acciones masivas */}
<div className="bulk-actions-wrap">
  <div className="bulk-left">
    {/* Master checkbox: selecciona/deselecciona todos los visibles */}
    <label className="select-square" title="Seleccionar visibles">
      <input
        type="checkbox"
        checked={
          finalDisplayedThreads.length > 0 &&
          finalDisplayedThreads.every(t => selectedIds.has(t.threadId))
        }
        onChange={(e) => e.target.checked ? selectAllVisible() : clearSelection()}
      />
      <span className="box" />
    </label>
    <span className="bulk-count">
      {selectedIds.size > 0 ? `${selectedIds.size} seleccionados` : ' '}
    </span>
    
  </div>

  {selectedIds.size > 0 && (
    <div className="bulk-right">
          <button className="bulk-btn" onClick={bulkMarkRead}>Marcar leído</button>
      <button className="bulk-btn" onClick={bulkMarkUnread}>Marcar no leído</button>

    {/* Etiquetas (Agregar/Quitar) */}
<div className="bulk-dropdown" ref={bulkTagsRef}>
  <button
    className="bulk-btn"
    onClick={(e) => {
      e.stopPropagation();
      setIsBulkTagsOpen((v) => !v); // click-toggle
      setIsBulkCrmOpen(false);      // cierra CRM si estaba abierto
    }}
  >
    Agregar/Quitar etiqueta ▾
  </button>

  <div className="bulk-menu" style={{ display: isBulkTagsOpen ? 'block' : 'none' }}>
    {tags.map((t) => {
      const appliedCount = selectedTagCounts.get(t.nombre) || 0;
      return (
        <div key={t.nombre} className="bulk-menu-item tag-with-actions">
          {/* Izquierda: AGREGAR a todos los seleccionados */}
          <div
            className="left"
            onClick={() => { bulkAddTag(t); setIsBulkTagsOpen(false); }}
            title="Agregar a los seleccionados"
          >
            <span className="tag-dot" style={{ background: t.color }} />
            {t.nombre}
          </div>

          {/* Derecha: QUITAR de los seleccionados que la tengan */}
          <button
            className="remove-x"
            disabled={appliedCount === 0}
            onClick={(e) => {
              e.stopPropagation();
              bulkRemoveTag(t);
              setIsBulkTagsOpen(false);
            }}
            title={
              appliedCount === 0
                ? 'Ninguno de los seleccionados tiene esta etiqueta'
                : `Quitar de ${appliedCount} chat(s)`
            }
            aria-label={`Quitar etiqueta ${t.nombre}`}
          >
            ×
          </button>
        </div>
      );
    })}
  </div>
</div>

{/* CRM */}
<div className="bulk-dropdown" ref={bulkCrmRef}>
  <button
    className="bulk-btn"
    onClick={(e) => {
      e.stopPropagation();
      setIsBulkCrmOpen((v) => !v);  // click-toggle
      setIsBulkTagsOpen(false);     // cierra Etiquetas si estaba abierto
    }}
  >
    Enviar al CRM ▾
  </button>

  <div className="bulk-menu" style={{ display: isBulkCrmOpen ? 'block' : 'none' }}>
    {crmColumns.map((c) => (
      <div
        key={c.id}
        className="bulk-menu-item"
        onClick={() => { bulkMoveToColumn(c.id); setIsBulkCrmOpen(false); }}
      >
        {c.name}
      </div>
    ))}
  </div>
</div>

      <button className="bulk-btn danger" onClick={bulkDelete}>Eliminar</button>
    </div>
  )}
</div>

  {activeTags.length > 0 && (
  <div className="tags-bar">
    {activeTags.map(nombre => {
      const tag = tags.find(t => t.nombre === nombre) || {};
      return (
<button
  key={nombre}
  className="tag-chip on"
  style={{
    background : tag.color,
    color      : isLightColor(tag.color) ? '#000' : '#FFF',
  }}
  onClick={() => setActiveTags(prev => prev.filter(n => n !== nombre))}
>
  {nombre} ×
</button>



      );
    })}
  </div>
)}{(loadingThreads || selectedTeamMember || selectedAgent) ? (
  <div className="threads-list-items" style={{ height: '100%', width: '100%', position: 'relative' }}>

  {/* ═══ ESTADOS DE CARGA Y FILTROS ═══ */}
  {isGlobalSearchOpen && isGlobalSearchLoading ? (
    <div className="global-search-loading">
      <div className="spinner" aria-label="Buscando…" />
      <span className="searching-text">Buscando en todos los chats…</span>
    </div>
  ) : (loadingThreads && threads.length === 0) ? (
    <div
      className="threads-loading-spinner"
      style={{ display:'flex', justifyContent:'center', alignItems:'center', width:'100%', padding:'2em 0' }}
    >
      <div className="spinner" aria-label="Cargando hilos…" />
    </div>
  ) : (hasTagFilter && loadingAllThreads && finalDisplayedThreads.length === 0) ? (
    /* Spinner cuando hay filtro por etiquetas pero aún no hay resultados */
    <div
      className="threads-loading-spinner"
      style={{ display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', width:'100%', padding:'2em 0', gap:'0.5em' }}
    >
      <div className="spinner" aria-label="Filtrando por etiquetas…" />
      <span style={{ color:'#AC9ED4', fontSize:'0.9em' }}>Filtrando por etiquetas…</span>
    </div>
  ) : finalDisplayedThreads.length === 0 ? (
    <div
      className="no-results-message"
      style={{ width:'90%', textAlign:'center', padding:'2em 1em', color:'#AC9ED4', lineHeight:1.6 }}
    >
      No se han encontrado resultados<br/>Intenta otras palabras clave o revisa los filtros aplicados
    </div>
  ) : (
<AutoSizer>
  {({ height, width }) => {
    const showSoftLoaderRow =
      loadingAllThreads && finalDisplayedThreads.length > 0;

    return (
      <>
        <List
          ref={listRef}
          height={height}
          width={width}
          itemCount={finalDisplayedThreads.length + (showSoftLoaderRow ? 1 : 0)}
          itemSize={getRowHeight}
          itemKey={(index) => {
            if (showSoftLoaderRow && index === finalDisplayedThreads.length) {
              return 'soft-loader-row';
            }
            const t = finalDisplayedThreads[index];
            return `${t.threadId}-${t.etiquetas?.length || 0}`;
          }}
          itemData={{
            threads: finalDisplayedThreads,
            handleThreadClick,
            toggleFavorite,
            renderThreadOptionsDropdown,
            isMoveMenuOpen,
            getPastelColor,
            getInitials,
            formatDate,
            isTeamRoute,
            showSoftLoaderRow, // 👈 pasamos el flag
            activeThreadId: threadId, 
              // 👇 nuevo
  isSelected,
  toggleSelectWithIndex,
          }}
onItemsRendered={({ visibleStopIndex }) => {
  // No paginar cuando hay filtros por etiquetas o búsqueda global
  if (hasTagFilter || isGlobalSearchOpen) return;

  // Paginamos cuando estemos cerca del final de lo que realmente se está mostrando
  if (visibleStopIndex >= finalDisplayedThreads.length - 10) {
    loadMoreThreads();
  }
}}

        >
          {ThreadRow}
        </List>

        {loadingMore && (
          <div style={{ display:'flex', justifyContent:'center', padding:'1rem' }}>
            <div className="loading-more-container" aria-label="Cargando más chats">
              <div className="spinner" />
            </div>
          </div>
        )}
      </>
    );
  }}
</AutoSizer>

  )}
</div>
            ) : (
              <div
                className="no-agent-message"
                style={{
                  flex: 1,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontSize: 'large',
                  textAlign: 'center',
                  padding: '1em'
                }}
              >
                <div className="spinner-container">
                  <div className="spinner"></div>
                </div>
              </div>
            )}
          </div>
  
          {/* DETALLE DEL THREAD SELECCIONADO */}
          {(selectedTeamMember || selectedAgent) ? (
            selectedThread ? (
              <div
                className="thread-details"
                style={{
                  backgroundImage: `url(${backgroundChat})`,
                  overflow: 'hidden',
                  backgroundColor: '#010321',
                  backgroundSize: 'auto',
                  backgroundRepeat: 'repeat',
                  backgroundAttachment: 'fixed',
                  display:
                    windowWidth <= 1000
                      ? showMobileThreadList
                        ? 'none'
                        : 'flex'
                      : 'flex',
                }}
              >
{showSummaryBox && (
  <div
    className="summary-modal-backdrop"
    onClick={() => setShowSummaryBox(false)}
  >
    <div
      className="summary-modal-content"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className="summary-modal-close-button"
        onClick={() => setShowSummaryBox(false)}
      >
        &times;
      </button>
      <h2 className="summary-modal-title">
  Resumen del chat con {selectedThread.senderName || 'usuario'}
</h2>

      <div className="summary-modal-body">
  <p dangerouslySetInnerHTML={{ __html: formatMessageContent(threadSummary) }} />
</div>

      <button
        className="summary-modal-action-button"
        onClick={() => setShowSummaryBox(false)}
      >
        Cerrar
      </button>
    </div>
  </div>
)}


                <div className="thread-details-content">

<div className="thread-info-header">
  {/* ── FILA SUPERIOR: remitente + acciones ── */}
  <div className="header-row">   {/* ← nuevo wrapper */}
    <div className="thread-info-sender">
{windowWidth <= 1000 && (
  <button
    className="mobile-back-button"
    onClick={() => {
      setShowMobileThreadList(true);
      setSelectedThread(null);
      const basePath = isTeamRoute
        ? `/messages/team-${teamMemberUniqueId}`
        : assistantId ? `/messages/${assistantId}` : '/messages';
      navigate(basePath, { replace: true });
    }}
  >
    <i className="fa fa-arrow-left mobile-arrow-icon-back" aria-hidden="true"></i>
  </button>
)}

                      {(!isSearchOpen || windowWidth > 1000) && (
                        <>
                          {selectedThread.phoneNumber ? (
                            <div
                              className="avatar-header-container"
                              style={{
                                backgroundColor: getPastelColor(
                                  selectedThread.senderName || 'Chat Web'
                                ),
                              }}
                            >
                              <span className="avatar-header-initials">
                                {getInitials(selectedThread.senderName || 'Chat Web')}
                              </span>
                              <FaWhatsapp className="whatsapp-icon-header" />
                            </div>
                          ) : (
                            <div className="web-chat-avatar-header-container">
                              <img
                                src={webChatIcon}
                                alt="Web Chat Icon"
                                className="web-chat-icon-header"
                              />
                            </div>
                          )}
                      <div className="sender-details">
  {isEditingSender ? (
    <>
      <div className="sender-edit-row">
        <input
          className="sender-edit-input"
          value={editedSenderName}
          onChange={e => setEditedSenderName(e.target.value)}
          onKeyDown={e => {
            if (e.key === 'Enter') saveSenderName();
            if (e.key === 'Escape') cancelEditSender();
          }}
          autoFocus
          placeholder="Nombre del contacto…"
        />
        <button className="sender-save-btn" onClick={saveSenderName} title="Guardar">
          <FontAwesomeIcon icon={faCheck} />
        </button>
        <button className="sender-cancel-btn" onClick={cancelEditSender} title="Cancelar">
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </div>

  
    </>
  ) : (
    <div className="sender-display-row">
      <span className="thread-sender-name-chat">
        {selectedThread.senderName || 'Chat Web'}
      </span>
      <button
        className="edit-sender-btn"
        onClick={startEditSender}
        title="Editar nombre"
      >
        <FontAwesomeIcon icon={faPencil} />
      </button>
    </div>
  )}

  {!isSearchOpen && selectedThread.phoneNumber && (
    <span className="thread-phone-number">
      {formatPhoneNumber(selectedThread.phoneNumber)}
    </span>
  )}
</div>

                        </>
                      )}
                    </div>
</div>

      <div className="add-contact">
{!isSearchOpen && (
  <div className="auto-response-container">

{/* 🔽 Solo visible para hordonez@mktmarketingdigital.com */}
{isHordonez && selectedThread && (
  <button
    className="summary-button download-conv-btn"
    onClick={handleDownloadConversation}
    title="Descargar conversación (JSON)"
    aria-label="Descargar conversación en JSON"
  >
    <div>
      <FontAwesomeIcon icon={faDownload} />
    </div>
  </button>
)}


<button
  className="summary-button"
  onClick={handleSummarizeThread}
  title="Generar resumen"
>
  {isSummarizing ? (
    <div className="spinner-summary" aria-label="Generando Resumen"></div>
  ) : (
    <div>  <FontAwesomeIcon icon={faFileAlt}/> <FontAwesomeIcon icon={faPencil} style={{ fontSize: '0.7em', marginBottom: '0.4em' }} /></div>

    
  )}
</button>


    {/* Icono principal (ej. faCog) que abre/cierra el menú */}
    <div
      className="auto-menu-toggle"
      onClick={() => setIsAutoMenuOpen(!isAutoMenuOpen)}
      title="Opciones de IA / Seguimiento"
    >
      <FontAwesomeIcon icon={faCog} />
    </div>
    

    {/* Menú desplegable con 3 "items" */}
    {isAutoMenuOpen && (
      <div className="auto-menu-dropdown">
        
        {/* (1) Botón para abrir el modal de "Asignar a miembro" */}
        <div
          className="auto-menu-item"
          onClick={() => {
            setIsTeamModalOpen(true);
            setIsAutoMenuOpen(false);
          }}
        >
          <img
            src={ControlAgenteIA}
            alt="Control Agente IA"
            className="control-agente-ia-icon"
          />
          <span className="control-agente-ia-span">Asignar miembro</span>
        </div>

         {/* NUEVA OPCIÓN: Agregar Nota */}
 <div
      className="auto-menu-item"
      onClick={() => {
        // Llamamos a la función para agregar nota
        handleAddNote();
        // Si deseas cerrar el menú después, también puedes hacerlo:
        setIsAutoMenuOpen(false);
      }}
    >
                <img
            src={AgregarNota}
            alt="Control Agente IA"
            className="control-agente-ia-icon"
          />
      <span>Agregar nota</span>
    </div>

        {/* (2) Switch IA (exactamente el snippet que querías) */}
        <div className="auto-menu-item">
          <div
            className="tooltip-switch"
            data-tooltip={finalAutoResponseEnabled ? 'IA ON' : 'IA OFF'}
          >
            <label className="switch">
            <input
  type="checkbox"
  checked={
    globalAutoResponseEnabled &&
    (selectedThread?.autoResponseEnabled ?? false)
  }
  onChange={toggleAutoResponse}
/>

              <span
                className={`slider-threads ${
                  finalAutoResponseEnabled ? 'on' : 'off'
                }`}
              />
            </label>

          </div>
          <span className="control-agente-ia-span">Inteligencia Artificial</span>
        </div>

        {/* (3) Botón de Tracking OFF/ON (gris vs #68379D) */}
        <div
  className={`global-tracking-button-threads ${
    selectedThread?.trackingActive ? 'on' : 'off'
  }`}
  onClick={() => {
    toggleThreadTracking();
    // Eliminado: setIsAutoMenuOpen(false);
  }}
>
  Seguimiento Individual
</div>

      </div>
    )}
  </div>
)}

                      {!isSearchOpen && (
                        <div
                          className="search-icon-wrapper"
                          onClick={() => setIsSearchOpen(!isSearchOpen)}
                          title="Buscar mensajes"
                        >
                          <FontAwesomeIcon icon={faSearch} className="search-icon" />
                        </div>
                      )}
                      {isSearchOpen && (
                        <div className="message-search-container">
                          <input
                            type="text"
                            className="message-search-input"
                            placeholder="Buscar en mensajes..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') handleMessageSearch();
                            }}
                          />
                          <button
                            className="search-now-button"
                            onClick={handleMessageSearch}
                            title="Buscar"
                          >
                            <FontAwesomeIcon icon={faSearch} />
                          </button>
                          {searchResults.length > 0 && (
                            <div className="search-navigation">
                              <button
                                onClick={goToPreviousSearchResult}
                                className="search-nav-button"
                                title="Anterior"
                              >
                                &larr;
                              </button>
                              <span className="search-counter">
                                {currentSearchIndex + 1} / {searchResults.length}
                              </span>
                              <button
                                onClick={goToNextSearchResult}
                                className="search-nav-button"
                                title="Siguiente"
                              >
                                &rarr;
                              </button>
                            </div>
                          )}
                          <button
                            className="global-search-close-button"
                            onClick={() => {
                              setIsSearchOpen(false);
                              setSearchQuery('');
                              setSearchResults([]);
                              setCurrentSearchIndex(0);
                            }}
                            aria-label="Cerrar búsqueda"
                          >
                            ×
                          </button>
                        </div>
                      )}
  
                      {selectedThread && !isSearchOpen && (
                        <div
                          className="options-thread-mobile"
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsMoveMenuOpen(
                              selectedThread.threadId === isMoveMenuOpen
                                ? null
                                : selectedThread.threadId
                            );
                          }}
                          style={{ marginLeft: '1em' }}
                        >
                          <FontAwesomeIcon icon={faEllipsisV} className="options-icon" />
                          {renderThreadOptionsDropdown(selectedThread)}
                        </div>
                      )}
                    </div>
  {/* ── FILA INFERIOR: teléfono ── */}
  {windowWidth <= 1000 && selectedThread?.phoneNumber && (
    <div className="phone-mobile">
      {formatPhoneNumber(selectedThread.phoneNumber)}
    </div>
  )}
</div>

{/* debajo del header, antes del <ul> */}
{selectedThread.conversationowner && (
  <div
    className={
      windowWidth <= 1000
        ? 'conversation-owner-mobile'   // mobile
        : 'conversation-owner'          // desktop
    }
  >
    <strong>Tomó el chat:</strong>{' '}
    <span className="owner-name-threads">
      {selectedThread.conversationowner}
    </span>
  </div>
)}

  
<ul
  ref={messageHistoryRef}
  className={`message-history ${
    selectedThread?.conversationowner ? 'chat-taken' : 'chat-free'
  }`}
>
                    {selectedThread.messageHistory.map((msg, index) => {

if (msg.role === 'nota' || msg.messageType === 'alert') {
  return (
<li key={index} className="message-item note-message fixed-above-input">
  <div className="note-content">
    <div
      className="note-text"
      dangerouslySetInnerHTML={{ __html: formatMessageContent(msg.content) }}
    />
    <div className="note-actions">
      <button onClick={(e) => { e.stopPropagation(); handleEditNote(msg); }}>Editar</button>
      <button onClick={(e) => { e.stopPropagation(); handleDeleteNote(msg); }}>Eliminar</button>
    </div>
    <span className="message-timestamp">{formatDate(msg.createdAt)}</span>
  </div>
</li>

  );
}
                      const isLast = index === selectedThread.messageHistory.length - 1;
                      const isFailed = msg.status === 'failed' && msg.errors && msg.errors.length > 0;
  const isPdf =
  msg.messageType === 'document' &&
  typeof msg.content === 'string' &&
  msg.content.toLowerCase().endsWith('.pdf');

  // Detecto si este mensaje es un PDF
  const isDocument = msg.messageType === 'document' && !isPdf;

  // Dentro de tu .map de messageHistory
const isImage = msg.messageType === 'image';

const isVideo = msg.messageType === 'video';
  
                      return (
                        <li
                          key={index}
                          className={`message-item ${msg.role}`}
                          style={{
                            display: 'flex',
                            justifyContent:
                              msg.role === 'user' ? 'flex-start' : 'flex-end', /* assistant y agent van a la derecha */
                            marginBottom: '0.6em'
                          }}
                          ref={(el) => {
                            messageRefs.current[index] = el;
                            if (isLast) lastMessageRef.current = el;
                          }}
                        >
                          <div
className={`message-content ${msg.role} ${isFailed ? 'message-failed' : ''} ${(isPdf || isImage || isDocument || isVideo) ? 'no-bg' : ''}`}
                            style={{
                              border: isFailed ? '2px solid red' : 'none',
                              background: isFailed
                                ? 'rgba(255, 0, 0, 0.2)'
                                : msg.messageType === 'audio'
                                ? 'none'
                                : '',
                              borderRadius: msg.messageType === 'audio' ? '0' : '12px',
                              padding:
                                 msg.messageType === 'audio'
      ? '0'                          // ► audios: sin padding
      : (isPdf || isImage || isDocument || isVideo)
      ? '0.6em 0em'                 // ► imgs / vids / docs: padding fino
      : '0.6em 4.8em 0.6em 1.2em',                // ► resto: padding habitual
                              maxWidth: msg.messageType === 'audio' ? '70%' : '45%',
                              alignSelf:
                                msg.role === 'user' ? 'flex-start' : 'flex-end',
                              width: 'fit-content',
                              marginRight: msg.messageType === 'audio' && msg.role !== 'user' ? '0em' : undefined,
                            }}
                          >
                            {/* Label para mensajes enviados desde WhatsApp Business App */}
                            {msg.role === 'agent' && (
                              <span className="agent-label">(WhatsApp Business App)</span>
                            )}
                            {/* Si el mensaje tiene info de campaña, se muestra la vista previa */}
                            {msg.metaCampaign && (
                              <div
                                className="meta-campaign-container"
                                style={{
                                  marginBottom: '0.5em',
                                  padding: '0.5em',
                                  backgroundColor: '#fff0',
                                  borderRadius: '5px'
                                }}
                              >
                                {msg.metaCampaign && msg.metaCampaign.preview_url ? (
                                  <img
                                    className="meta-campaign-image"
                                    src={msg.metaCampaign.preview_url}
                                    alt={msg.metaCampaign.name}
                                    style={{
                                      width: '100%',
                                      height: 'auto',
                                      borderRadius: '0',
                                      objectFit: 'cover'
                                    }}
                                  />
                                ) : (
                                  <span>Imagen no disponible</span>
                                )}
  
                                <div
                                  className="meta-campaign-info"
                                  style={{ display: 'flex', flexDirection: 'column' }}
                                >
                                  <strong style={{ fontSize: '0.9em' }}>
                                    {msg.metaCampaign.name}
                                  </strong>
                                  <span
                                    style={{ fontSize: '0.8em', color: '#fff' }}
                                  >
                                    {msg.metaCampaign.description}
                                  </span>
                                </div>
  
                                <div className="meta-campaign-link-container">
                                  {msg.metaCampaign &&
                                  (msg.metaCampaign.publicationLink ||
                                    msg.metaCampaign.source_url) ? (
                                    <a
                                      href={
                                        msg.metaCampaign.publicationLink ||
                                        msg.metaCampaign.source_url
                                      }
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="meta-campaign-link"
                                      style={{
                                        fontSize: '0.9em',
                                        color: '#CDBDF9',
                                        textDecoration: 'none'
                                      }}
                                    >
                                      Ver publicación
                                    </a>
                                  ) : (
                                    <span
                                      className="meta-campaign-link"
                                      style={{ fontSize: '0.8em', color: '#999' }}
                                    >
                                      URL: no disponible
                                    </span>
                                  )}
                                </div>
                              </div>
                            )}
  
{/* Resto del contenido del mensaje, según su tipo */}
{(() => {
  // 1) Si viene como texto y el contenido es una URL válida...
  if ((msg.messageType === 'text' || !msg.messageType) && typeof msg.content === 'string') {
    const text = msg.content.trim();
    const isPureUrl = /^https?:\/\/\S+$/i.test(text);

    if (isPureUrl) {
      try {
        const urlObj = new URL(text);                 // valida que sea URL
      const pathname = urlObj.pathname;             // p.ej. "/carpeta/mi-video.mp4"
      const ext = pathname.split('.').pop().toLowerCase(); // "mp4"

      const imageExts  = ['png','jpg','jpeg','gif','webp'];
      const audioExts  = ['mp3','wav','ogg','webm','aac'];
      const videoExts  = ['mp4','webm','ogg','mov','avi','mkv'];
      const docExts    = ['pdf','csv','txt'];
      const officeExts = ['docx','xlsx','pptx'];

      if (imageExts.includes(ext)) {
        return (
          <img
            src={text}
            alt="Imagen recibida"
            style={{ maxWidth: '100%', borderRadius: '10px' }}
          />
        );
      }
      if (audioExts.includes(ext)) {
        return (
          <VoiceMessagePlayer src={text} timestamp={formatDate(msg.createdAt)} style={{ width: '100%' }} />
        );
      }
      if (videoExts.includes(ext)) {
        return (
          <video controls style={{ width: '100%', minWidth: '300px' }}>
            <source src={text} />
            Tu navegador no soporta el elemento de video.
          </video>
        );
      }
      if (ext === 'pdf') {
        return (
          <embed
            src={text}
            type="application/pdf"
            width="100%"
            height="500px"
          />
        );
      }
      if (docExts.includes(ext) && ext !== 'pdf') {
        return (
          <embed
            src={text}
            type={ext === 'csv' ? 'text/csv' : 'text/plain'}
            width="100%"
            height="500px"
          />
        );
      }
      if (officeExts.includes(ext)) {
        const officeViewerUrl =
          `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(text)}`;
        return (
          <iframe
            src={officeViewerUrl}
            width="100%"
            height="500px"
            frameBorder="0"
            title="Documento Office"
          />
        );
      }

      // Si es una URL válida pero no coincide con ningún tipo anterior,
      // la mostramos como enlace:
        return (
          <a href={text} target="_blank" rel="noopener noreferrer">
            {text}
          </a>
        );
      } catch (e) {
        // no es URL válida → cae al switch
      }
    }
  }

  // 2) Si no es un texto-URL reconocido, switch normal por messageType
  switch (msg.messageType) {
    case 'image':
      return (
        <div>
          <img
            src={msg.content}
            alt="Imagen recibida"
            style={{ maxWidth: '100%', borderRadius: '10px' }}
          />
          {msg.caption && (
            <p style={{ marginTop: '5px', fontStyle: 'italic' }}>
              {msg.caption}
            </p>
          )}
        </div>
      );

    case 'audio':
      return (
        <VoiceMessagePlayer src={msg.content} timestamp={formatDate(msg.createdAt)} style={{ width: '100%' }} />
      );

    case 'video':
      return (
        <video controls style={{ width: '100%', minWidth: '300px' }}>
          <source src={msg.content} />
          Tu navegador no soporta el elemento de video.
        </video>
      );

    case 'office': {
      const officeViewerUrl =
        `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
          msg.content
        )}`;
      return (
        <iframe
          src={officeViewerUrl}
          width="100%"
          height="500px"
          frameBorder="0"
          title="Documento Office"
        />
      );
    }
    case 'pdf':             // ← nuevo
      return (
        <embed
          src={msg.content}
          type="application/pdf"
          width="100%"
          height="500px"
        />
      );

    case 'document': {
      const urlLower = msg.content.toLowerCase();
      if (urlLower.endsWith('.pdf')) {
        return (
          <embed
            src={msg.content}
            type="application/pdf"
            width="100%"
            height="500px"
          />
        );
      } else if (urlLower.endsWith('.csv') || urlLower.endsWith('.txt')) {
        return (
          <embed
            src={msg.content}
            type={urlLower.endsWith('.csv') ? 'text/csv' : 'text/plain'}
            width="100%"
            height="500px"
          />
        );
      } else {
        const gViewerUrl =
          `https://docs.google.com/viewer?embedded=true&url=` +
          encodeURIComponent(msg.content);
        return (
          <iframe
            src={gViewerUrl}
            style={{ width: '100%', height: '500px', border: 'none' }}
            title="Vista previa documento"
          />
        );
      }
    }

    default:
      return (
        <>
          {msg.isTranscription && (
            <span
              style={{
                fontSize: '0.85em',
                opacity: 0.7,
                marginRight: '0.5em',
                fontStyle: 'italic'
              }}
              title="Transcripción de audio"
            >
              🎤
            </span>
          )}
          <span
            className="message-text"
            style={{
              fontStyle: msg.isTranscription ? 'italic' : 'normal',
              color: msg.isTranscription ? '#dcdcdc' : 'inherit',
              opacity: msg.isTranscription ? 0.85 : 1,
            }}
            dangerouslySetInnerHTML={{
              __html: msg.isTranscription
                ? `<em style="font-style:italic; color:#dcdcdc;">${msg.content}</em>`
                : formatMessageContent(msg.content)
            }}
          />
        </>
      );
  }
})()}



                            {/* El cartel rojo con el error */}
                            {isFailed && (
                              <div
                                className="failed-banner"
                                style={{
                                  marginTop: '10px',
                                  backgroundColor: '#fff0',
                                  color: 'white',
                                  padding: '10px',
                                  borderRadius: '4px'
                                }}
                              >
                                <strong
                                  style={{ fontSize: '1.15em', fontFamily: 'Outfit' }}
                                >
                                  ¡Error al enviar!
                                </strong>
                                <br />
                                <span
                                  style={{
                                    fontSize: '0.9em',
                                    fontFamily: 'Poppins'
                                  }}
                                >
                                  {msg.errors[0].title}
                                </span>
                                <br />
                                {msg.errors[0].error_data?.details && (
                                  <small
                                    style={{
                                      fontSize: '0.85em',
                                      fontStyle: 'italic'
                                    }}
                                  >
                                    {msg.errors[0].error_data.details}
                                  </small>
                                )}
                              </div>
                            )}
{msg.messageType !== 'audio' && (
  <span className="message-timestamp">
    {formatDate(msg.createdAt)}
  </span>
)}

                          </div>
                        </li>
                      );
                    })}
  



                  </ul>
  
                  {/* Aviso si pasan 24 hs, etc. */}
                  {selectedThread?.phoneNumber && freezeIfLastNormalOver24h && (
                    <div className="recontact-advice">
                      Para{' '}
                      <span style={{ fontWeight: 600 }}>recontactar</span>{' '}
                      a este usuario, necesitas enviar una{' '}
                      <span style={{ fontWeight: 600 }}>
                        plantilla aprobada por Meta.
                      </span>
                      <br />
                      <p className="meta-warning">
                        *No disponible si no has agregado un método de pago a tu
                        Meta Business Manager*
                      </p>
  
                      <strong>
                        Elige una plantilla{' '}
                        <img
                          src={flechaBaja}
                          alt="Flecha hacia abajo"
                          style={{
                            width: '12px',
                            marginLeft: '4px'
                          }}
                        />
                      </strong>
                    </div>
                  )}
  
                  {selectedThread?.phoneNumber && disableTemplateControls && (
                    <div className="recontact-advice" style={{ lineHeight: '1.5em' }}>
                      <strong>¡Alerta!</strong> <br />
                      Ya le has enviado a este usuario <strong>2 plantillas en 24 horas</strong>{' '}
                      sin recibir respuesta.
                      <br />
                      Hasta que el usuario responda o transcurran 24hs 
                      desde la última plantilla, <strong><u>no se puede volver a recontactar</u>.</strong>
                    </div>
                  )}
  
                  {selectedThread?.phoneNumber &&
                    selectedThread.templateCountNoReply24h === 1 &&
                    olderThan24 && (
                      <div
                        className="recontact-advice"
                        style={{ padding: '1.5em 1em' }}
                      >
                        Has enviado una plantilla recientemente. Aún puedes enviar
                        <strong> 1 plantilla más</strong> a este contacto.
                      </div>
                    )}
  

                    {/* Modal Team */}
                    {isTeamModalOpen && (
  <div
    className="team-modal-backdrop"
    onClick={() => setIsTeamModalOpen(false)}
  >
    <div
      className="team-modal-messages"
      onClick={(e) => e.stopPropagation()}
    >
      <h2 className="team-modal-title">
        Selecciona un Miembro del Equipo
      </h2>

      <ul className="team-modal-list">
        {teamMembers.map((member) => {
          // "isAssigned" = true si la conversación YA está asignada a este miembro
          const isAssigned = selectedThread?.conversationownerId === member.id;

          return (
            <li
              key={member.id}
              className="team-modal-item member-option"
              // Al hacer clic => alternar asignar/desasignar
              onClick={() => handleToggleTeamMember(member)}
            >
              {/* Cuadradito: Check si isAssigned === true */}
              <div className="member-option-checkbox">
                {isAssigned && <span>✓</span>}
              </div>

              <div className="team-member-info">
                <span className="team-member-name">
                  {member.nombre} {member.apellido}
                </span>
                {member.cargo && (
                  <span className="team-member-role">
                    {member.cargo}
                  </span>
                )}
              </div>
            </li>
          );
        })}
      </ul>

      <button
        className="team-modal-close-button"
        onClick={() => setIsTeamModalOpen(false)}
      >
        Cerrar
      </button>
    </div>
  </div>
)}
                  {/* Previews tipo WhatsApp — barra horizontal encima del input */}
                  {previewURLs.length > 0 && (
                    <div className="file-preview-bar">
                      {previewURLs.map((preview, idx) => (
                        <div
                          key={idx}
                          className={`file-preview-chip ${preview.type === 'audio' ? 'audio' : ''}`}
                        >
                          <button
                            className="remove-file-chip"
                            onClick={() => handleRemoveFile(idx)}
                            aria-label={`Eliminar ${preview.name}`}
                          >
                            ×
                          </button>
                          {preview.type === 'image' && (
                            <img
                              src={preview.url}
                              alt={preview.name}
                              className="preview-chip-thumb"
                              onClick={() => openPreviewModal(idx)}
                            />
                          )}
                          {preview.type === 'video' && (
                            <video
                              src={preview.url}
                              className="preview-chip-thumb"
                              muted
                              onClick={() => openPreviewModal(idx)}
                            />
                          )}
                          {preview.type === 'audio' && (
                            <VoiceMessagePlayer
                              src={preview.url}
                              className="preview-audio"
                              style={{ width: '100%', minWidth: 'unset', maxWidth: 'unset' }}
                            />
                          )}
                          {preview.type === 'document' && (
                            <div className="preview-chip-doc">
                              <span>{preview.name}</span>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}

                  <div className="new-message-container">
                    {/* Íconos de emojis, adjuntos */}
                    <div
                      className="message-icons"
                      style={{ display: 'flex', alignItems: 'center' }}
                    >
                     
                      <img
                        src={clipIconChat}
                        alt="Adjuntar"
                        className="message-icon"
                        style={{
                          opacity: disableNormalControls ? 0.2 : 1,
                          pointerEvents: disableNormalControls ? 'none' : 'auto',
                          marginLeft: '0',
                        }}
                        onClick={() => {
                          if (!disableNormalControls) {
                            handleFileIconClick();
                          }
                        }}
                      />
                      <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                        multiple
                        onChange={handleFileChange}
                      />
  
                    
                    </div>
  
                    {showEmojiPicker && (
                      <div
                        ref={emojiPickerRef}
                        style={{
                          position: 'absolute',
                          bottom: '60px',
                          left: '20px',
                          zIndex: 999
                        }}
                      >
                        <EmojiPicker
                          onEmojiClick={(emojiData) => {
                            setNewMessage((prev) => prev + emojiData.emoji);
                          }}
                        />
                      </div>
                    )}
  
                    {/* INPUT MENSAJE + ICONO PLANTILLAS */}
                    <div className="input-with-icon-container">
                      <textarea
                        className="new-message-input"
                         ref={inputRef}
                        rows={1}
                        style={{
                          opacity: disableNormalControls ? 0.2 : 1,
                          pointerEvents: disableNormalControls ? 'none' : 'auto',
                        }}
                        placeholder="Escribe tu mensaje..."
                        value={newMessage}
                        onFocus={() => setIsInputFocused(true)}       
                        onBlur={()  => setIsInputFocused(false)}       
                        onChange={(e) => setNewMessage(e.target.value)}
onPaste={(e) => {
    e.preventDefault();
    const plain = e.clipboardData.getData('text/plain');

    // posición del cursor / selección
    const textarea = inputRef.current;
    const start = textarea.selectionStart;
    const end   = textarea.selectionEnd;

    // inserta el texto pegado manteniendo lo anterior
    setNewMessage((prev) => prev.slice(0, start) + plain + prev.slice(end));

    // opcional: re-coloca el cursor justo después de lo pegado
    requestAnimationFrame(() => {
      const pos = start + plain.length;
      textarea.setSelectionRange(pos, pos);
    });
  }}
                        onKeyDown={(e) => {
                          if (
                            e.key === 'Enter' &&
                            !e.shiftKey &&
                            !e.ctrlKey &&
                            !e.metaKey
                          ) {
                            e.preventDefault();
                            handleSendMessage();
                          }
                        }}
                        disabled={isInputDisabled}
                      />
  {/* Ícono EMOJI dentro del input */}
<img
  src={emojiIconChat}
  alt="Emoji"
  className="emoji-icon-inside-input"
  style={{
    opacity:
      disableNormalControls ? 0.2 : 1,
    pointerEvents:
      disableNormalControls ? 'none' : 'auto',
    paddingRight: '0.5em',
  }}
  onClick={(e) => {
    e.stopPropagation();
    if (!disableNormalControls) {
      setShowEmojiPicker(!showEmojiPicker);
    }
  }}
/>

                      {/* Ícono FaFile para PLANTILLAS */}
                      {isCreatingDefaults ? (
                        <div
                          className="spinner-plantillas"
                          style={{ width: 26, height: 26, margin: '0 0' }}
                        />
                      ) : (
                        <img
                          src={seleccionarPlantillas}
                          alt="Seleccionar Plantilla"
                          className="file-icon-inside-input"
                          style={{
                            opacity:
                              disableTemplateControls || !isWhatsAppThread
                                ? 0.2
                                : 1,
                            pointerEvents:
                              disableTemplateControls || !isWhatsAppThread
                                ? 'none'
                                : 'auto',
                            borderRight: '1px solid rgba(255, 255, 255, 0.3)',
                            paddingRight: '0.4em',
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (!disableTemplateControls) {
                              setShowTemplateDropdown(!showTemplateDropdown);
                            }
                          }}
                        />
                      )}
  
                      {/* Dropdown de plantillas */}
                      {showTemplateDropdown && (
                        <div ref={templateDropdownRef} className="template-dropdown">
                          {/* Opción para usar plantillas predeterminadas */}
                          <div
                            className="template-option"
                            style={{
                              fontStyle: 'italic',
                              color: '#FFF',
                              fontSize: '0.8em',
                              filter: hasAllDefaultTemplates ? 'blur(1px)' : 'none',
                              cursor: hasAllDefaultTemplates ? 'not-allowed' : 'pointer',
                              pointerEvents: hasAllDefaultTemplates ? 'none' : 'auto',
                              opacity: hasAllDefaultTemplates ? 0.5 : 1
                            }}
                            onClick={() => {
                              if (hasAllDefaultTemplates) return;
                              const ok = window.confirm(
                                '¿Deseas crear las plantillas predeterminadas?'
                              );
                              if (!ok) return;
                              setShowTemplateDropdown(false);
                              createDefaultTemplates();
                            }}
                          >
                            Solicitar predeterminadas
                          </div>
  
                          <hr style={{ margin: '0.5em 0' }} />
  
                          {availableTemplates.map((tpl) => (
                            <div
                              key={tpl.name}
                              className="template-option"
                              onClick={() => {
                                if (chosenTemplate === tpl.name) {
                                  // Des-seleccionar
                                  setChosenTemplate(null);
                                  setNewMessage('');
                                  setShowTemplateDropdown(true);
                                } else {
                                  // Seleccionar
                                  setChosenTemplate(tpl.name);
                                  if (defaultBodyMap[tpl.name]) {
                                    setNewMessage(defaultBodyMap[tpl.name]);
                                  } else {
                                    setNewMessage('texto de tu plantilla');
                                  }
                                }
                              }}
                            >
                              <div className="template-option-checkbox">
                                {chosenTemplate === tpl.name && <span>✓</span>}
                              </div>
                              <span>{tpl.name}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div> 
  
                    {/* Botón de enviar */}
  {/* === BOTÓN DINÁMICO MIC / ENVIAR === */}
  {(
    /* mostrar ENVIAR si hay texto, archivos o el textarea tiene foco */
    newMessage.trim().length > 0 ||
    selectedFiles.length > 0   ||
    isInputFocused
  ) ? (
    /* ---- BOTÓN ENVIAR ---- */
    <button
      className="send-message-button"
      onClick={handleSendMessage}
      disabled={disableTemplateControls || isSending}
      style={{
        opacity      : disableTemplateControls ? 0.2 : 1,
        pointerEvents: disableTemplateControls ? 'none' : 'auto',
      }}
    >
      {isSending ? (
        <div className="spinner" aria-label="Enviando"></div>
      ) : (
        <div className="send-button-with-badge">
          <img src={paperClipButton} alt="Enviar" className="send-button-image" />
          {selectedFiles.length > 0 && (
            <span className="send-badge">{selectedFiles.length}</span>
          )}
        </div>
      )}
    </button>
  ) : (
    /* ---- BOTÓN MICRÓFONO / GRABANDO ---- */
    <button
      className="send-message-button"
      onClick={isRecording ? stopRecording : startRecording}
      disabled={disableNormalControls}
      style={{
        opacity      : disableNormalControls ? 0.2 : 1,
        pointerEvents: disableNormalControls ? 'none' : 'auto',
      }}
      title={isRecording ? 'Detener grabación' : 'Grabar audio'}
    >
      {isRecording ? (
        <FontAwesomeIcon icon={faStop} className="detener-audio" style={{ color: 'red' }} />
      ) : (
        <img src={microphoneIcon} className="grabar-audio" alt="Grabar audio" />
      )}
    </button>
  )}
                  </div>
                </div>
              </div>
            ) : (
              <div className="no-thread-selected" />
            )
          ) : (
            <div className="no-agent-selected" />
          )}
        </>
      )}
  
      {/* Aquí, al final, los modales que van *afuera* de .thread-details */}
      {showTiendaNubeModal && (
        <div className="modal-backdrop" onClick={() => setShowTiendaNubeModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <TiendaNubeConnectForm onClose={() => setShowTiendaNubeModal(false)} />
          </div>
        </div>
      )}
  
      {showConversationLimitModal && (
        <div className="conversation-limit-modal-backdrop">
          <div className="conversation-limit-modal">
            <button
              className="conversation-limit-close-button"
              onClick={() => setShowConversationLimitModal(false)}
            >
              ×
            </button>
            <h2 className="conversation-limit-title">Sin conversaciones disponibles</h2>
            <p className="conversation-limit-text">
              Has agotado tus conversaciones gratuitas. <br />
              Debes comprar más en{' '}
              <a
                href="https://thethingapp.com/precios"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://thethingapp.com/precios
              </a>. <br />
              La IA no responderá y no podrás enviar nuevos mensajes.
            </p>
            <button
              className="conversation-limit-button"
              onClick={() =>
                window.open('https://thethingapp.com/precios', '_blank', 'noopener,noreferrer')
              }
            >
              Comprar más conversaciones
            </button>
          </div>
        </div>
      )}
  
      {isModalOpen && (
        <div className="modal-backdrop" onClick={closePreviewModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="modal-close-button"
              onClick={closePreviewModal}
              aria-label="Cerrar modal"
            >
              ×
            </button>
            <div className="modal-images-container">
              {previewURLs.map((preview, idx) => (
                <div
                  key={idx}
                  className={`modal-image-item ${
                    idx === currentPreviewIndex ? 'active' : ''
                  }`}
                >
                  {preview.type === 'image' && (
                    <img
                      src={preview.url}
                      alt={`Detalle ${preview.name}`}
                      className="modal-image"
                    />
                  )}
                  {preview.type === 'video' && (
                    <video src={preview.url} controls className="modal-video" />
                  )}
                  {preview.type === 'document' && (
                    <div className="modal-document">
                      <p>{preview.name}</p>
                    </div>
                  )}
                  <button
                    className="remove-file-button-modal"
                    onClick={() => handleRemoveFile(idx)}
                    aria-label={`Eliminar ${preview.name}`}
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
{showTrackingPhraseModal && (
  <div
    className="modal-backdrop"
    onClick={() => setShowTrackingPhraseModal(false)}
  >
    <div className="modal-seguimiento" onClick={(e) => e.stopPropagation()}>
      {/* Botón de cierre (X) similar al modal del resumen */}
      <button
        className="summary-modal-close-button"
        onClick={() => setShowTrackingPhraseModal(false)}
        aria-label="Cerrar modal"
      >
        &times;
      </button>

      <h2>Selecciona frase de seguimiento</h2>

      <ul>
        {trackingPhrases.map((phrase, idx) => {
          const isSelected = selectedTrackingPhrase === phrase;
          const isDefaultPhrase = DEFAULT_RECONTACT_PHRASES.includes(phrase);
          return (
            <li
              key={idx}
              className="tracking-phrase-item"
              onClick={() => {
                setSelectedTrackingPhrase(isSelected ? '' : phrase);
              }}
            >
              <div className="tracking-phrase-checkbox">
                {isSelected && <span>✓</span>}
              </div>
              <div className="tracking-phrase-text">
                {phrase}
              </div>
              {!isDefaultPhrase && (
                <button
                  className="delete-phrase-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    const confirmDelete = window.confirm(`¿Eliminar la frase "${phrase}"?`);
                    if (confirmDelete) {
                      removeTrackingPhrase(phrase);
                    }
                  }}
                  style={{
                    marginLeft: '0.5em',
                    backgroundColor: '#b33',
                    color: '#fff',
                    border: 'none',
                    cursor: 'pointer',
                    borderRadius: '4px',
                    padding: '0.2em 0.4em'
                  }}
                >
                  Eliminar
                </button>
              )}
            </li>
          );
        })}
      </ul>

      <button
        className="add-phrase-button"
        onClick={() => {
          const nuevo = window.prompt('Escribe tu nueva frase de seguimiento:');
          if (nuevo && nuevo.trim()) {
            addTrackingPhrase(nuevo.trim());
          }
        }}
      >
        + Agregar nueva frase
      </button>

      <div style={{ marginTop: '1em' }}>
        <button
          className="activate-phrase-button"
          onClick={() => {
            if (!selectedTrackingPhrase) {
              toast.info('ℹ️ Debes seleccionar una frase primero');
              return;
            }
            doForceTrackingToggle(true, selectedTrackingPhrase);
            setShowTrackingPhraseModal(false);
          }}
          style={{ marginRight: '1em' }}
        >
          Activar seguimiento
        </button>

        <button
          className="deactivate-phrase-button"
          onClick={() => {
            doForceTrackingToggle(false, '');
            setShowTrackingPhraseModal(false);
          }}
          style={{ marginRight: '1em', backgroundColor: '#993333' }}
        >
          Desactivar seguimiento
        </button>
      </div>
    </div>
  </div>
)}



    </div>
  );
  
};

export default ThreadsViewer;